function collapsed_expander(obj) {
   $(obj).toggleClass('title-active');
    var collapse_content_selector = $(obj).next();
    var expander = $(obj);  
    if (!$(collapse_content_selector).hasClass("open")) {  
      expander.addClass("open") ;
    } else {
      expander.removeClass("open");  
    }
    if (!$(collapse_content_selector).hasClass("open")){
      $('#SMFiltersForm .block-title').removeClass("open");     
      $('#SMFiltersForm .sm__display').removeClass("open").slideUp("normal");       
      $(collapse_content_selector).addClass("open").slideDown("normal");
    } else {
      $(collapse_content_selector).removeClass("open").slideUp("normal");       
    }      
}

(function($) {
  $(document).ready(function() {
      smartaddonSS();
      var sections = new smartaddonSS.Sections();
      sections.register('product-template', smartaddonSS.Product);
      sections.register('header-section', smartaddonSS.HeaderSection);
	  if ($('body').hasClass('template-product') ) {
		sections.register('product-template', Shopify.Products.showRecentlyViewed());
		sections.register('product-template', Shopify.Products.recordRecentlyViewed());
        sections.register('product-recommendations', smartaddonSS.ProductRecommendations);
        $(window).on( "scroll", function() {  
          $( ".product__info-media" ).css({"position":"sticky"});
          $( ".product__info-container" ).css({"position":"sticky"});
        });
        $(window).off( "scroll", function() {  
          $( ".product__info-media" ).css("position","relative");
          $( ".product__info-container" ).css("position","relative");
        });     
        color_compare();
      }  
      if ($('body').hasClass('template-search') || $('body').hasClass('template-collection')) {
        ajaxify();
      }
      initaddjs();
      updateMiniCart();
      buildCart();
      showPopup();
      hidePopup();
      hidePu();     
      initCurenty();
      btnAddtocart();
      cartModalupdate();
      updatePricingQuickview();
      initInfiniteScrollingHomepage();
      initAddToCart();
      initQuickView();
      initProductAddToCart();
      initInstaGram();
      initCountd();
      initScrolling();
      productsTabs();
      productsTabsDetail();
      reinitView();
      initlOwlCarousel();
      initlSlick();
      initcolor();  
      initpopupVideo();
      product_real_time();
      product_count_sales();
      buys_together_home();
      ask_a_question();
      single_product_share();
      estimated_delivery_time(); 
      estimated_delivery();
      checkbox_terms_conditions_agree();
      smartaddonSS.click_atribute_image();
      smartaddonSS.pick_up();
      smartaddonSS.lookbook();
      new smartaddonSS.update_variant_cartpage('.js-edit_variants');
      if (window.settings.enableGiftCard) {
    		new smartaddonSS.gift_wrap('.ss-giftcard');
      }    
  })

  $(document).keyup(function(e) {
    if (e.keyCode == 27) {
      hidePopup();
    }
  });
	
  smartaddonSS = function(settings) {
      settings = settings || {},
      init = function() {
      },
  
  window.smartaddonSS = window.smartaddonSS || {};

// LookBook SECTION
smartaddonSS.lookbook = function(){

    $('.lookbook-style2 .lookbook-button-card,.lookbook-style2 .close').on( "click", function() {
        var $id = $(this).data('image');
        if($(".products-listing[data-image-card='"+$id+"']").hasClass('hidden')) {
           $(".products-listing[data-image-card='"+$id+"']").removeClass('hidden');
        } else {
          $(".products-listing[data-image-card='"+$id+"']").addClass('hidden');
        }  
    });
  
	$(window).on("click.Bst", function(event){
		var $box = $('.ss-section--lookbook:not(.lookbook-simple) .content-product-card .product-card');
		var $box2 = $('.ss-section--lookbook:not(.lookbook-simple) .lookbook-card__point');
		if ( $box.has(event.target).length == 0 && !$box.is(event.target) && $box2.has(event.target).length == 0 && !$box2.is(event.target) ) {
			if($('.ss-section--lookbook:not(.lookbook-simple) .content-product-card').hasClass("active")){
				$('.ss-section--lookbook:not(.lookbook-simple) .content-product-card').removeClass("active").removeAttr('style');
				$('.ss-section--lookbook:not(.lookbook-simple) .lookbook-card__btn').removeClass("active");
			}
		}
	});
	$(".ss-section--lookbook:not(.lookbook-simple) .close-lookbook").on( "click", function() {
		if($('.ss-section--lookbook:not(.lookbook-simple) .content-product-card').hasClass("active")){
			$('.ss-section--lookbook:not(.lookbook-simple) .content-product-card').removeClass("active").removeAttr('style');
			$('.ss-section--lookbook:not(.lookbook-simple) .lookbook-card__btn').removeClass("active");
		}
	});
	$(".ss-section--lookbook:not(.lookbook-simple) .lookbook-card__btn").on( "click", function() {
		var $parent = $(this).closest('.ss-section--lookbook:not(.lookbook-simple)');
		var $id = $(this).data("target")
		var x = $(this).offset();
		$('.content-product-card',$parent).removeClass("active").removeAttr('style');
		$('.lookbook-card__btn',$parent).removeClass("active");
		if($(this).hasClass("active")){
			$(this).removeClass("active");
			$("#"+$id+"",$parent).removeClass("active").removeAttr('style');
		}else{
			$(this).addClass("active");
			$("#"+$id+"",$parent).addClass("active").css({"top": x.top, "left": x.left});
		}
	});
	$(".ss-section--lookbook.lookbook-split .ss-lookbook__item").mouseover(function(){
		if(!$(this).hasClass("active")){
			$(".ss-section--lookbook.lookbook-split .ss-lookbook__item").removeClass("active");
			$(this).addClass("active");
			if($('.ss-section--lookbook.lookbook-split .content-product-card').hasClass("active")){
				$('.ss-section--lookbook.lookbook-split .content-product-card').removeClass("active").removeAttr('style');
				$('.ss-section--lookbook.lookbook-split .lookbook-card__btn').removeClass("active");
			}
		}
	});
	$(".ss-section--lookbook.lookbook-simple .lookbook-card__btn").on( "click", function() {
		var $parent = $(this).closest('.ss-section--lookbook.lookbook-simple');
		var $element = $(this).closest('.lookbook__item');
		var $id = $(this).data("target")
		if(!$(this).hasClass("active")){
			$('.content-product-card',$element).removeClass("active");
			$('.lookbook-card__btn',$element).removeClass("active");
			$(this).addClass("active");
			$("#"+$id+"",$parent).addClass("active");
			var slick_current = $("#"+$id+"",$parent).data('slick-index');
			$('.lookbook-product',$element).slick('slickGoTo',slick_current);
		}
	});
}

    
// HEADER SECTION
smartaddonSS.HeaderSection = (function() {
  
  var selectors = {
    disclosureLocale: '[data-disclosure-locale]',
  };

  function Header(container) {
    this.$container = $(container);
    this.cache = {};
    this.cacheSelectors();
    var $body = $('body');
    
    if (this.cache.$localeDisclosure.length) {
		this.localeDisclosure = new smartaddonSS.Disclosure(
			this.cache.$localeDisclosure
		);
    }
  }    

  Header.prototype = _.assignIn({}, Header.prototype, {
    
    cacheSelectors: function() {
      this.cache = {
        $localeDisclosure: this.$container.find(selectors.disclosureLocale),
      };
    },

    onUnload: function() {
      if (this.cache.$localeDisclosure.length) {
        this.localeDisclosure.unload();
      }
    }
  });

  return Header;  
})();
                         
smartaddonSS.Disclosure = (function() {
    
	var selectors = {
		disclosureInput: '[data-disclosure-input]',
		disclosureOptions: '[data-disclosure-option]'
	};
	function Disclosure($disclosure) {
		this.$container = $disclosure;
		this.cache = {};
		this._cacheSelectors();
		this._connectOptions();
      
	}
	Disclosure.prototype = _.assignIn({}, Disclosure.prototype, {
		_cacheSelectors: function() {
			this.cache = {
				$disclosureInput: this.$container.find(selectors.disclosureInput),
				$disclosureOptions: this.$container.find(selectors.disclosureOptions)
			};
		},
		_connectOptions: function() {
           
			this.cache.$disclosureOptions.on('click',function(evt) {
				evt.preventDefault();
				this._submitForm($(evt.currentTarget).data('value'));
                
			}.bind(this));
		},
		_submitForm: function(value) {
			this.cache.$disclosureInput.val(value);
			this.$container.parents('form').submit();
		},
		unload: function() {
			this.cache.$disclosureOptions.off();
			this.$container.off();
		}
	});
	return Disclosure;
})();

smartaddonSS.gift_wrap = (function() {
	var selectors = {
		body: 'body',
		GiftCard: '[data-gift-card]',
		giftWrapTemplate: '#gift-card-template',
		giftWrapBtn: '.gift-wrap [data-gift_card]',
		giftCardContainer: '[data-gift-card-container]',
		giftCardClose: '[data-gift-card-close]',
		giftCardImages: '[data-gift-card-images]',
		giftCardVariant: '.js-giftcard-option-selector',
		originalSelectorId: '[data-edit_variant-variant]',
		giftCardProductPrice: '.js-gift-product-price',
		giftCardProductPriceCompare: '.js-gift-product-price-compare',
		giftCardQty: '[data-gift-card-quantity]',
		giftCardAvaiable: '.product-avaiable',
		giftCardAvaiableInStock: '.product-avaiable--instock',
		giftCardAvaiableOutStock: '.product-avaiable--outstock',
		giftCardProductDetailsURL: '.js-qv-product-details'
	};
	function GiftCard(container) {
		this.$container = $(container);
		this.cache = {};
		this.productVariants = [];
		this.currentVariant = {};
		this.cacheSelectors();
		this.initializeEvents();
	}
	GiftCard.prototype = _.assignIn({}, GiftCard.prototype, {
		cacheSelectors: function() {
			this.cache = {
				$body: $('body'),
				$giftCardContainer: this.$container.find(selectors.giftCardContainer)
			};
		},

		initializeEvents: function() {
			var $this = this;
			$(selectors.body).on('click', selectors.giftWrapBtn, function(e) {
				e.preventDefault();
				var productHandle = $(this).data('gift_card');
				$(this).addClass('load-giftcard');
				$.getJSON('/products/' + productHandle + '.js', function(product) {
					if (product.available) {
					$this.firstAvailableVariant(product.variants, $this);
					} else {
						$this.currentVariant = product.variants[0];
					}
					$(selectors.giftWrapBtn).removeClass('load-giftcard');
					$this.buildGiftCard(product);
					$this.show();
					$this.createImageCarousel(product);
				});
			});
			$(selectors.body).on('click', selectors.giftCardClose, function(e) {
				e.preventDefault();
				$this.hide();
			});
			$(selectors.giftCardContainer).on('change', selectors.giftCardVariant, function(e) {
				$this.onVariantChange();
			});
		},

		firstAvailableVariant: function(variants, global) {
			global.productVariants = variants;
			for (var i = 0; i < variants.length; i++) {
				var variant = variants[i];
				if (variant.available) {
					global.currentVariant = variant;
					break;
				}
			}
		},
		buildGiftCard: function(product) {
			var moneyFormat = window.money_format;
			var currentVariant = this.currentVariant;
			var source = $(selectors.giftWrapTemplate).html();
			var template = Handlebars.compile(source);
			var images = '';
			var price = '';
			var external='';
			var qvObject = {
				id: product.id
			};
			if (typeof product.media !== 'undefined') {
				images += '<div class="gift_card-images__list slick-carousel" data-gift-card-images>'
				for (var i = 0; i < product.media.length; i++) {
					var media = product.media[i];
					if (media.media_type === 'image') {
						images += '<div class="slick-carousel__item"><div class="giftcard-images__item" data-media-id=' +
							media.id + '><img class="img-fluid" alt="' +
							product.title + '" src="' +
							media.src + '" /></div></div>';
					}
				}
				images += '</div>'
			}			
			qvObject.variantID = currentVariant.id;
			qvObject.sku = currentVariant.sku !== null && currentVariant.sku !== '' ? currentVariant.sku : 'N/A';
			qvObject.images = images;
			qvObject.title = product.title;
			qvObject.url = product.url;
			price += '<div class="price-container">';
			var productCompareClass = product.compare_at_price !== null ? '' : 'd-none';
			price += '<div class="js-gift-product-price-compare product-single__price--compare-at ' + productCompareClass + '">' + smartaddons.Currency.formatMoney(product.compare_at_price, moneyFormat) + '</div>';
			price += '<div class="js-gift-product-price product-single__price">' + smartaddons.Currency.formatMoney(product.price, moneyFormat) + '</div>';
			price += '</div">';
			qvObject.price = price;
			qvObject.variants = this.buildVariant(product);
			$(selectors.giftCardContainer).html(template(qvObject));
			// AFTER BUILD HTML
			this.updateMedia(currentVariant);
			this.updateDetailsLink(currentVariant);
			$('#form-gift-card-addtocart .btn--add-to-cart').on('click',function(e){
				e.preventDefault();
				$(this).removeClass('added');
				$(this).addClass('active');
				let addToCartForm = document.querySelector('#form-gift-card-addtocart');
				let formData = new FormData(addToCartForm);
				var params = {
					type: 'POST',
					url: '/cart/add.js',
					data: formData,
					processData: false,
					contentType: false,
					dataType: 'json',
					success: function(line_item) {
						$('#form-gift-card-addtocart .btn--add-to-cart').removeClass('active');
						$('#form-gift-card-addtocart .btn--add-to-cart').addClass('added');
						setTimeout(function() {
							$('#form-gift-card-addtocart .btn--add-to-cart').removeClass('added');
						}, 3000);
                        updateMiniCart();
						if( $('body').hasClass('template-cart') ){
							setTimeout(function(){
								window.location.reload(true);
							}, 800);
						}                      
					},
					error: function(XMLHttpRequest, textStatus) {
						if (typeof errorCallback === 'function') {
							errorCallback(XMLHttpRequest, textStatus);
						} else {
							ShopifyAPI.onError(XMLHttpRequest, textStatus);
						}
					}
				};
				jQuery.ajax(params);
			});
            if( $('.currency-Picker').length > 0){
                Currency.convertAll(window.shop_currency, jQuery('select[name=currencies] option:selected').val(), 'span.money', 'money_format');
            }  
		},
		convertToSlug: function(str) {
			return str.toLowerCase().replace(/[^a-z0-9 -]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-');
		},
		buildVariant: function(product) {
			var result = '';
			var currentVariant = this.currentVariant;
			if (product.options[0].name !== 'Title') {
				var options = product.options;
				for (var i = 0; i < options.length; i ++) {
					var option = options[i];
					var optionIndex = i + 1;
					result += '<div class="variants-wrapper product-form__item" data-giftcard-variant-option="' + optionIndex + '">';
					result += '<label class="variants__label">' + option.name + '</label>';
					result += '<div class="variants__options">';
					for (var j = 0; j < option.values.length; j ++) {
						var value = option.values[j];
						var isDisable = true;
						var colorAttribute = '';
						// CHECK Product option is available or disabled
						for (var k = 0; k < this.productVariants.length; k ++) {
							var variantCondition = this.productVariants[k];
							if (variantCondition.available) {
								if (i == 0 && variantCondition.option1 === value) {
									isDisable = false;
									break;
								} else if (i == 1 && variantCondition.option2 === value && variantCondition.option1 == currentVariant.option1) {
									isDisable = false;
									break;
								} else if (i == 2 && variantCondition.option3 === value && variantCondition.option2 == currentVariant.option2 && variantCondition.option1 == currentVariant.option1) {
									isDisable = false;
									break;
								}
							}
						}
						// RENDER Product option button
						result += '<div class="single-option-selector">';
						result += '<input type="radio" data-single-option-button';
						result += currentVariant.options[i] === value ? ' checked ' : ' ';
						if (isDisable) {
							result += 'disabled="disabled"';
						}
						result += 'value="' + _.escape(value) + '" data-index="option' + optionIndex + '" name="option' + option.position + '" ';
						result += 'class="js-giftcard-option-selector';
						if (isDisable) {
							result += ' disabled';
						}
						result += '" id="giftcard-product-option-' + i + '-' + value.toLowerCase() + '">';
						result += '<label data-toggle="tooltip" title="' + value + '" for="giftcard-product-option-' + i + '-' + value.toLowerCase() + '" ' + colorAttribute;
						if (isDisable) {
							result += ' class="disabled"';
						}
						result += '>' + value + '<span class="d-none"></span></label>';
						result += '</div>';
					}
					result += '</div>';
					result += '</div>';
				}
			}
			return result;
		},
		createImageCarousel: function(product) {
			if(product.media.length > 1){
				$(selectors.GiftCard).find(selectors.giftCardImages).slick({
					infinite: false,
					rows: 0,
					arrows: false
				});
			}
		},
		getCurrentOptions: function() {
			var currentOptions = _.map(
				$(selectors.giftCardVariant, selectors.giftCardContainer), function(element) {
					var $element = $(element);
					var type = $element.attr('type');
					var currentOption = {};
					if (type === 'radio' || type === 'checkbox') {
						if ($element[0].checked) {
							currentOption.value = $element.val();
							currentOption.index = $element.data('index');
							return currentOption;
						} else {
							return false;
						}
					} else {
						currentOption.value = $element.val();
						currentOption.index = $element.data('index');
						return currentOption;
					}
				}
			);
			currentOptions = _.compact(currentOptions);
			return currentOptions;
		},
		getVariantFromOptions: function() {
			var selectedValues = this.getCurrentOptions();
			var variants = this.productVariants;
			var found = _.find(variants, function(variant) {
				return selectedValues.every(function(values) {
					return _.isEqual(variant[values.index], values.value);
				});
			});
			return found;
		},
		updateVariantsButton: function () {
			var selectedValues = this.getCurrentOptions();
			var variants = this.productVariants;
			for (var i = 2; i <= 3; i++) {
				if ($('[data-giftcard-variant-option="' + i + '"]', selectors.giftCardContainer).length) {
					$('[data-giftcard-variant-option="' + i + '"] ' + selectors.giftCardVariant, selectors.giftCardContainer).each(function() {
						var $self = $(this);
						var optionValue = $self.val();
						var foundIndex;
						if (i === 2) {
							foundIndex = _.findIndex(variants, function(variant) {
								variant.option1 = variant.option1.toString();
								selectedValues[0].value = selectedValues[0].value.toString();
								variant.option2 = variant.option2.toString();
								optionValue = optionValue.toString();
								return variant.option1 === selectedValues[0].value &&
								variant.option2 === optionValue &&
								variant.available === true;
							});
							
						} else if (i === 3) {
							foundIndex = _.findIndex(variants, function(variant) {
								variant.option1 = variant.option1.toString();
								variant.option2 = variant.option2.toString();
								variant.option3 = variant.option3.toString();
								selectedValues[0].value = selectedValues[0].value.toString();
								selectedValues[1].value = selectedValues[1].value.toString();
								optionValue = optionValue.toString();
								return variant.option1 === selectedValues[0].value && variant.option2 === selectedValues[1].value &&
								variant.option3 === optionValue &&
								variant.available === true;
							});
						}
						if (foundIndex !== -1) {
							$self.removeAttr('disabled', 'disabled').removeClass('disabled');
							$self.next('label').removeClass('disabled');
						} else {
							$self.attr('disabled', 'disabled').addClass('disabled');
							$self.next('label').addClass('disabled');
						}
					});
				}
			}
		},
		updateVariantsButtonDisabed: function() {
			for (var i = 2; i <= 3; i++) {
				if ($('[data-giftcard-variant-option="' + i + '"]', selectors.giftCardContainer).length) {
					var isUpdate = false;
					$('[data-giftcard-variant-option="' + i + '"] ' + selectors.giftCardVariant, selectors.giftCardContainer).each(function() {
						var $element = $(this);
						var type = $element.attr('type');
						if (type === 'radio' || type === 'checkbox') {
							if (this.checked && $element.hasClass('disabled')) {
								$element.prop('checked', false);
								isUpdate = true;
								return false;
							}
						}
					});
					$('[data-giftcard-variant-option="' + i + '"] ' + selectors.giftCardVariant, selectors.giftCardContainer).each(function() {
						var $element = $(this);
						var type = $element.attr('type');
						if (isUpdate && (type === 'radio' || type === 'checkbox') && !$element.hasClass('disabled')) {
							$element.prop('checked', true);
							isUpdate = false;
							$element.trigger('change');
							return false;
						}
					});
				}
			}
		},
		updateMasterSelect: function(variant) {
			if (variant) {
				$(selectors.originalSelectorId, selectors.giftCardContainer).val(variant.id);
			}
		},
		updateMedia: function(variant) {
			if (variant && variant.featured_media && variant.featured_media.id) {
				$(selectors.giftCardImages, selectors.giftCardContainer).find('.giftcard-images__item').each(function() {
					var imageID = $(this).data('media-id');
					if (variant.featured_media.id == imageID) {
						var slickIndex = $(this).closest('.slick-carousel__item').data('slick-index');
						if (slickIndex !== undefined && slickIndex !== null) {
							$(selectors.giftCardImages, selectors.giftCardContainer).slick('slickGoTo', slickIndex);
						}
					}
				});
			}
		},

		updatePrice: function(variant) {
			var moneyFormat = window.money_format;
			if (!variant) {
				$(selectors.giftCardProductPrice, selectors.giftCardContainer).addClass('d-none');
				$(selectors.giftCardProductPriceCompare, selectors.giftCardContainer).addClass('d-none');
			} else {
				$(selectors.giftCardProductPrice, selectors.giftCardContainer).removeClass('d-none');
				$(selectors.giftCardProductPriceCompare, selectors.giftCardContainer).removeClass('d-none');
				$(selectors.giftCardProductPrice, selectors.giftCardContainer).html(
					smartaddons.Currency.formatMoney(variant.price, moneyFormat)
				);
				if (variant.compare_at_price > variant.price) {
					$(selectors.giftCardProductPriceCompare, selectors.giftCardContainer).html(
						smartaddons.Currency.formatMoney(variant.compare_at_price, moneyFormat)
					).removeClass('d-none');
					$(selectors.giftCardProductPrice, selectors.giftCardContainer).addClass('on-sale');
				} else {
					$(selectors.giftCardProductPriceCompare, selectors.giftCardContainer).addClass('d-none');
					$(selectors.giftCardProductPrice, selectors.giftCardContainer).removeClass('on-sale');
				}
			}
            if( $('.currency-Picker').length > 0){
                Currency.convertAll(window.shop_currency, jQuery('select[name=currencies] option:selected').val(), 'span.money', 'money_format');
            }  
		},

		updateProductAvaiable: function(variant) {
			var classActive = 'product-avaiable--active';
			var translations = window.trans_text;
			$(selectors.giftCardAvaiable, selectors.giftCardContainer).removeClass(classActive);
			if (variant) {
				if (variant.available) {
					$(selectors.giftCardQty, selectors.giftCardContainer).removeClass('d-none');
					$(selectors.giftCardAvaiableInStock, selectors.giftCardContainer).addClass(classActive);
				} else {
					$(selectors.giftCardQty, selectors.giftCardContainer).addClass('d-none');
					$(selectors.giftCardAvaiableOutStock, selectors.giftCardContainer).addClass(classActive);
				}
				// Button add to cart
				if (variant.available) {
					$(selectors.giftCardContainer).find('.btn--add-to-cart')
						.removeClass('disabled')
						.prop('disabled', false);
					$(selectors.giftCardContainer).find('.btn--add-to-cart .btn__text').html(translations.add_to_cart);
				} else {
					$(selectors.giftCardContainer).find('.btn--add-to-cart')
						.addClass('disabled')
						.prop('disabled', true);
					$(selectors.giftCardContainer).find('.btn--add-to-cart .btn__text').html(translations.sold_out);
				}
			} else {
				$(selectors.giftCardQty, selectors.giftCardContainer).addClass('d-none');
				$(selectors.giftCardContainer).find('.btn--add-to-cart')
					.addClass('disabled')
					.prop('disabled', true);
				$(selectors.giftCardContainer).find('.btn--add-to-cart .btn__text').html(translations.unavailable);
			}
		},

		updateDetailsLink: function(variant) {
			if (variant) {
				var productURL = $(selectors.giftCardProductDetailsURL, selectors.giftCardContainer).data('url') + '?variant=' + variant.id;
				$(selectors.giftCardProductDetailsURL, selectors.giftCardContainer).removeClass('d-none').attr('href', productURL);
			} else {
				$(selectors.giftCardProductDetailsURL, selectors.giftCardContainer).addClass('d-none');
			}
		},

		onVariantChange: function() {
			var variant = this.getVariantFromOptions();
			if ($('[data-single-option-button]', selectors.giftCardContainer).length) {
				this.updateVariantsButton();
				if (!variant || !variant.available) {
					this.updateVariantsButtonDisabed();
					return;
				}
			}
			this.updateMasterSelect(variant);
			this.updateMedia(variant);
			this.updatePrice(variant);
			this.updateProductAvaiable(variant);
			this.updateDetailsLink(variant);
			this.currentVariant = variant;
		},
		show: function() {
			$(selectors.body).addClass('giftcard-active');
			$(selectors.GiftCard).addClass('show');
			setTimeout(function(){
				$('.gift_card-container .gift_card__content').addClass('show');
			}, 400);
		},
		hide: function() {
			$(selectors.giftCardContainer).html();
			$(selectors.body).removeClass('giftcard-active');
			$('.gift_card-container .gift_card__content').removeClass('show');
			setTimeout(function(){
				$(selectors.GiftCard).removeClass('show');
			}, 400);
		}
	});
	return GiftCard;
})();
               
//ProductRecommendations
smartaddonSS.ProductRecommendations = (function() {
  function ProductRecommendations(container) {
    this.$container = $(container);
    var self = this;
    var baseUrl = this.$container.data('baseUrl');
    var productId = this.$container.data('productId');
    var recommendationsSectionUrl =
      baseUrl +
      '?section_id=product-recommendations&product_id=' +
      productId +
      '&limit='+window.settingsrecommendations.product_recommendations_limit;
    $.get(recommendationsSectionUrl).then(function(section) {
      var recommendationsMarkup = $(section).html();
      if (recommendationsMarkup.trim() !== '') {
        self.$container.html(recommendationsMarkup);
		var $config = $('[data-section-type="product-recommendations"]');
		var $title = $('[data-section-type="product-recommendations"]').data('title');
		var $element = $('.owl-carousel',self.$container);
        $('.section-product-recommendations .box-title h3').html($title);
    		$element.owlCarousel({
    			slidesToShow: $config.data('columns'),
    			autoplay : $config.data('autoplay'),
    			autoplaySpeed: $config.data('autoplayspeed'),
    			nav : $config.data('nav'),
                navText: ['<svg fill="currentcolor" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><polygon fill-rule="evenodd" points="9.414 12 16.707 19.293 15.293 20.707 6.586 12 15.293 3.293 16.707 4.707"/></svg>', '<svg fill="currentcolor" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><polygon fill-rule="evenodd" points="14.586 12 7.293 4.707 8.707 3.293 17.414 12 8.707 20.707 7.293 19.293"/></svg>'],
                navClass: ["owl-prev", "owl-next"],             
                margin: $config.data('margin'),
    			infinite : $config.data('infinite'),
    			slidesToScroll : $config.data("slidestoscroll") ? $config.data("columns") : 1,
                rtl : window.routes.rtl,   
                responsive:{
                  0:{
                    items:1,
                  },
                  320:{
                    items:$config.data("column5"),
                  },
                  480:{
                    items:$config.data("column4"),
                  },
                  767:{
                    items: $config.data("column3"),
                  },
                  991:{
                    items:$config.data("column2"),
                    nav: $config.data('navigation'),
                  },
                  1199:{
                    items:$config.data("column1") ? $config.data("column1") : $config.data("column1440"),
                    nav: $config.data('navigation'),
                  },
                }    			
    			
    		});
        
            smartaddonSS.click_atribute_image();
            initCountd();
            initButtonsWishlist();
            initButtonsCompare();        
            if( $('.currency-Picker').length > 0){
                Currency.convertAll(window.shop_currency, jQuery('select[name=currencies] option:selected').val(), 'span.money', 'money_format');
            }        
      }
    });
  }
  return ProductRecommendations;
})();

smartaddonSS.update_variant_cartpage = (function() {
	var selectors = {
		body: 'body',
		EditVariant: '[data-edit_variant-cart]',
		EditVariantTemplate: '#edit_variants-template',
		EditVariantBtn: '.cart-product-edit_variant',
		EditVariantContainer: '[data-edit_variant-cart-container]',
		EditVariantClose: '[data-edit_variant-cart-close]',
		EditVariantImages: '[data-edit_variant-images]',
		EditVariantVariant: '.js-edit_variant-option-selector',
		originalSelectorId: '[data-edit_variant-variant]',
		EditVariantProductPrice: '.price-item--sale',
		EditVariantProductPriceCompare: '.product-price--regular',
		EditVariantQty: '[data-edit_variant-quantity]',
		EditVariantAvaiable: '.product-avaiable',
		EditVariantAvaiableInStock: '.product-avaiable--instock',
		EditVariantAvaiableOutStock: '.product-avaiable--outstock',
		EditVariantDetailsURL: '.js-qv-product-details'
	};
	function EditVariant(container) {
		this.$container = $(container);
		this.cache = {};
		this.productVariants = [];
		this.currentVariant = {};
		this.cacheSelectors();
		this.initializeEvents();
	}
	EditVariant.prototype = _.assignIn({}, EditVariant.prototype, {
		cacheSelectors: function() {
			this.cache = {
				$body: $('body'),
				$EditVariantContainer: this.$container.find(selectors.EditVariantContainer)
			};
		},

		initializeEvents: function() {
			var $this = this;
			$(selectors.body).on('click', selectors.EditVariantBtn, function(e) {
				e.preventDefault();
				var productHandle = $(this).data('handle');
				var qty = $(this).data('value');
				var line = $(this).data('line');
				var id_variant = $(this).data('id_variant');
				var $parent = $(this).closest('.content-edit_variant-popup');
				$(this).addClass('load-edit_variant');
				$('.image-popup',$parent).addClass('imagepopup_active');
				$('body').addClass('editv_overlay-layer');
				$.getJSON('/products/' + productHandle + '.js', function(product) {
					if (product.available) {
					$this.firstAvailableVariant(product.variants, $this);
					} else {
						$this.currentVariant = product.variants[0];
					}
					$(selectors.EditVariantBtn).removeClass('load-edit_variant');
					$this.buildEditVariant(product,qty,line,id_variant);
					var $element = $('.edit_variant-cart-container .content_product_detail .variants-wrapper')
					$($element).each(function() {
						var $this = $(this);
						var value = $('input:checked',$this).attr('value');
						$('.variants__label span',$this).html(value);
					});
					$(selectors.EditVariantContainer).on('change', selectors.EditVariantVariant, function(e) {
						$this.onVariantChange(id_variant);
					});
					if ($(window).width() < 767) {
						$(selectors.EditVariant).addClass('transform');
					}else{
						$(selectors.EditVariant).addClass('transform');
					}
				});
			});
			$(selectors.body).on('click', selectors.EditVariantClose, function(e) {
				if ($(window).width() < 767) {
					$(selectors.EditVariant).removeClass('transform');
					$('body').removeClass('editv_overlay-layer');
					setTimeout(function() {
						$('[data-edit_variant-cart-container]').empty();
					},300);
				}else{
					$(selectors.EditVariant).removeClass('transform');
					setTimeout(function() { 
						$('body').removeClass('editv_overlay-layer');
						$('[data-edit_variant-cart-container]').empty();
					},300);
				}
			});
			$(selectors.body).on('click', function(e) {
				if( $(e.target).is('body.editv_overlay-layer')) {
					if ($(window).width() < 767) {
						$(selectors.EditVariant).removeClass('transform');
						$('body').removeClass('editv_overlay-layer');
						setTimeout(function() {
							$('[data-edit_variant-cart-container]').empty();
						},300);
					}else{
						$(selectors.EditVariant).removeClass('transform');
						setTimeout(function() { 
							$('body').removeClass('editv_overlay-layer');
							$('[data-edit_variant-cart-container]').empty();
						},300);
					}
				}
			});
		},

		firstAvailableVariant: function(variants, global) {
			global.productVariants = variants;
			for (var i = 0; i < variants.length; i++) {
				var variant = variants[i];
				if (variant.available) {
					global.currentVariant = variant;
					break;
				}
			}
		},
		buildEditVariant: function(product,qty,line,id_variant) {
			var moneyFormat = window.money_format;
			var currentVariant = this.currentVariant;
			for (var key in product.variants) {
				if (id_variant == product.variants[key].id) {
					var currentVariant = product.variants[key];
				}
			}
			var source = $(selectors.EditVariantTemplate).html();
			var template = Handlebars.compile(source);
			var images = '';
			var price = '';
			var external='';
			var qvObject = {
				id: product.id
			};
			if (typeof product.media !== 'undefined') {
				images += '<div class="edit_variant-images__list slick-carousel" data-edit_variant-images>'
				for (var i = 0; i < product.media.length; i++) {
					var media = product.media[i];
					if (media.media_type === 'image') {
						if ( i == 0 ) {
							images += '<div class="slick-carousel__item show"><div class="edit_variant-images__item" data-media-id=' +
								media.id + '><img class="img-fluid" alt="' +
								product.title + '" src="' +
								media.src + '" /></div></div>';
						}else{
							images += '<div class="slick-carousel__item"><div class="edit_variant-images__item" data-media-id=' +
								media.id + '><img class="img-fluid" alt="' +
								product.title + '" src="' +
								media.src + '" /></div></div>';
						}
					}
				}
				images += '</div>'
			}			
            var pricevariant = 0;
            if (typeof product.variants !== 'undefined') {
                for (var i = 0; i < product.variants.length; i++) {
                    var variant = product.variants[i];
                    if(id_variant === variant.id) {
                      pricevariant = variant.price;
                    }
                }
            }
          
			qvObject.variantID = currentVariant.id;
			qvObject.sku = currentVariant.sku !== null && currentVariant.sku !== '' ? currentVariant.sku : 'N/A';
			qvObject.images = images;
			qvObject.title = product.title;
			qvObject.qty = qty;
			qvObject.line = line;
			qvObject.url = product.url;
			price += '<div class="price-container">';
			var productCompareClass = product.compare_at_price !== null ? '' : 'd-none';
			price += '<div class="product-price product-price--regular ' + productCompareClass + '">' + smartaddons.Currency.formatMoney(product.compare_at_price, moneyFormat) + '</div>';
			price += '<div class="price-item--sale product-price variant-price">' + smartaddons.Currency.formatMoney(pricevariant, moneyFormat) + '</div>';
			price += '</div">';
			qvObject.price = price;
			qvObject.variants = this.buildVariant(product,id_variant);
			$(selectors.EditVariantContainer).html(template(qvObject));
            if( $('.currency-Picker').length > 0){
                Currency.convertAll(window.shop_currency, jQuery('select[name=currencies] option:selected').val(), 'span.money', 'money_format');
            }           
			// AFTER BUILD HTML
			this.updateMedia(currentVariant);
			this.updateDetailsLink(currentVariant);
         
			$('#form-edit_variants-addtocart .btn-ss-add-to-cart').on('click',function(e){
				e.preventDefault();
				var $parent = $(this).closest('.product-edit_variants');
				$(this).removeClass('added');
				$(this).addClass('active');
				let addToCartForm = document.querySelector('#form-edit_variants-addtocart');
				let formData = new FormData(addToCartForm);
				var params = {
					type: 'POST',
					url: '/cart/add.js',
					data: formData,
					processData: false,
					contentType: false,
					dataType: 'json',
					success: function(cart) {
						var line = $parent.data('line') + 1;
						$('#form-edit_variants-addtocart .btn-ss-add-to-cart').removeClass('active');
						$('#form-edit_variants-addtocart .btn-ss-add-to-cart').addClass('added');
						setTimeout(function() {
							$('#form-edit_variants-addtocart .btn-ss-add-to-cart').removeClass('added');
						}, 2000);
						ShopifyAPI.changeItem(line, 0);
						setTimeout(function(){
							updateMiniCart();
                            buildCart();
						}, 100);
						if( $('body').hasClass('template-cart') ){
							setTimeout(function(){
								window.location.reload(true);
							}, 800);
						}
					},
					error: function(XMLHttpRequest, textStatus) {
						if (typeof errorCallback === 'function') {
							errorCallback(XMLHttpRequest, textStatus);
						} else {
							ShopifyAPI.onError(XMLHttpRequest, textStatus);
						}
					}
				};
				jQuery.ajax(params);
			});
		},
		convertToSlug: function(str) {
			return str.toLowerCase().replace(/[^a-z0-9 -]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-');
		},
		buildVariant: function(product,id_variant) {
			var result = '';
			var currentVariant = this.currentVariant;
			for (var key in product.variants) {
				if (id_variant == product.variants[key].id) {
					var currentVariant = product.variants[key];
				}
			}
			if (product.options[0].name !== 'Title') {
				var options = product.options;
				for (var i = 0; i < options.length; i ++) {
					var option = options[i];
					var optionIndex = i + 1;
					var type = 'label';
					if (window.settings.filter_name_1 === option.name) {
						type = window.settings.select_filter_1;
					}else if (window.settings.filter_name_2 === option.name) {
						type = window.settings.select_filter_2;
					}else if (window.settings.filter_name_3 === option.name) {
						type = window.settings.select_filter_3;
					}
					result += '<div class="variants-wrapper product-form__item '+ type +'" data-edit_variants-variant-option="' + optionIndex + '">';
					result += '<label class="variants__label">' + option.name + ': <span></span></label>';
					result += '<div class="variants__options">';
					for (var j = 0; j < option.values.length; j ++) {
						var value = option.values[j];
						var isDisable = true;
						var colorAttribute = '';
						// CHECK Product option is available or disabled
						for (var k = 0; k < this.productVariants.length; k ++) {
							var variantCondition = this.productVariants[k];
							if (variantCondition.available) {
								if (i == 0 && variantCondition.option1 === value) {
									isDisable = false;
									break;
								} else if (i == 1 && variantCondition.option2 === value && variantCondition.option1 == currentVariant.option1) {
									isDisable = false;
									break;
								} else if (i == 2 && variantCondition.option3 === value && variantCondition.option2 == currentVariant.option2 && variantCondition.option1 == currentVariant.option1) {
									isDisable = false;
									break;
								}
							}
						}
						// RENDER Product option button
						result += '<div class="single-option-selector">';
						result += '<input type="radio" data-single-option-button';
						result += currentVariant.options[i] === value ? ' checked ' : ' ';
						if (isDisable) {
							result += 'disabled="disabled"';
						}
						result += 'value="' + _.escape(value) + '" data-index="option' + optionIndex + '" name="option' + option.position + '" ';
						result += 'class="js-edit_variant-option-selector';
						if (isDisable) {
							result += ' disabled';
						}
						result += '" id="edit_variants-product-option-' + i + '-' + value.toLowerCase() + '">';
						result += '<label  data-toggle="tooltip" title="' + value + '" for="edit_variants-product-option-' + i + '-' + value.toLowerCase() + '" ' + colorAttribute;
						if (isDisable) {
							result += ' class="' + value + ' disabled"';
						} else {
                            result += ' class="' + value + '"';
                        }
						result += '>' + value + '<span class="tool-tip">' + value + '</span></label>';
						result += '</div>';
					}
					result += '</div>';
					result += '</div>';
				}
			}          
			return result;
		},
		createImageCarousel: function(product) {
			if(product.media.length > 1){
				$(selectors.EditVariant).find(selectors.EditVariantImages).slick({
					infinite: false,
					rows: 0,
					fade: true,
					rtl : window.routes.rtl
				});
			}
		},
		getCurrentOptions: function() {
			var currentOptions = _.map(
				$(selectors.EditVariantVariant, selectors.EditVariantContainer), function(element) {
					var $element = $(element);
					var type = $element.attr('type');
					var currentOption = {};
					if (type === 'radio' || type === 'checkbox') {
						if ($element[0].checked) {
							currentOption.value = $element.val();
							currentOption.index = $element.data('index');
							return currentOption;
						} else {
							return false;
						}
					} else {
						currentOption.value = $element.val();
						currentOption.index = $element.data('index');
						return currentOption;
					}
				}
			);
			currentOptions = _.compact(currentOptions);
			return currentOptions;
		},
		getVariantFromOptions: function() {
			var selectedValues = this.getCurrentOptions();
			var variants = this.productVariants;
			var found = _.find(variants, function(variant) {
				return selectedValues.every(function(values) {
					return _.isEqual(variant[values.index], values.value);
				});
			});
			return found;
		},
		updateVariantsButton: function () {
			var selectedValues = this.getCurrentOptions();
			var variants = this.productVariants;
			for (var i = 2; i <= 3; i++) {
				if ($('[data-edit_variants-variant-option="' + i + '"]', selectors.EditVariantContainer).length) {
					$('[data-edit_variants-variant-option="' + i + '"] ' + selectors.EditVariantVariant, selectors.EditVariantContainer).each(function() {
						var $self = $(this);
						var optionValue = $self.val();
						var foundIndex;
						if (i === 2) {
							foundIndex = _.findIndex(variants, function(variant) {
								variant.option1 = variant.option1.toString();
								selectedValues[0].value = selectedValues[0].value.toString();
								variant.option2 = variant.option2.toString();
								optionValue = optionValue.toString();
								return variant.option1 === selectedValues[0].value &&
								variant.option2 === optionValue &&
								variant.available === true;
							});
							
						} else if (i === 3) {
							foundIndex = _.findIndex(variants, function(variant) {
								variant.option1 = variant.option1.toString();
								variant.option2 = variant.option2.toString();
								variant.option3 = variant.option3.toString();
								selectedValues[0].value = selectedValues[0].value.toString();
								selectedValues[1].value = selectedValues[1].value.toString();
								optionValue = optionValue.toString();
								return variant.option1 === selectedValues[0].value && variant.option2 === selectedValues[1].value &&
								variant.option3 === optionValue &&
								variant.available === true;
							});
						}
						if (foundIndex !== -1) {
							$self.removeAttr('disabled', 'disabled').removeClass('disabled');
							$self.next('label').removeClass('disabled');
						} else {
							$self.attr('disabled', 'disabled').addClass('disabled');
							$self.next('label').addClass('disabled');
						}
					});
				}
			}
		},
		updateVariantsButtonDisabed: function() {
			for (var i = 2; i <= 3; i++) {
				if ($('[data-edit_variants-variant-option="' + i + '"]', selectors.EditVariantContainer).length) {
					var isUpdate = false;
					$('[data-edit_variants-variant-option="' + i + '"] ' + selectors.EditVariantVariant, selectors.EditVariantContainer).each(function() {
						var $element = $(this);
						var type = $element.attr('type');
						if (type === 'radio' || type === 'checkbox') {
							if (this.checked && $element.hasClass('disabled')) {
								$element.prop('checked', false);
								isUpdate = true;
								return false;
							}
						}
					});
					$('[data-edit_variants-variant-option="' + i + '"] ' + selectors.EditVariantVariant, selectors.EditVariantContainer).each(function() {
						var $element = $(this);
						var type = $element.attr('type');
						if (isUpdate && (type === 'radio' || type === 'checkbox') && !$element.hasClass('disabled')) {
							$element.prop('checked', true);
							isUpdate = false;
							$element.trigger('change');
							return false;
						}
					});
				}
			}
		},
		updateMasterSelect: function(variant) {
			if (variant) {
				$(selectors.originalSelectorId, selectors.EditVariantContainer).val(variant.id);
			}
		},
		updateLabelvariant: function(variant) {
			var $element = $('.edit_variant-cart-container .content_product_detail .variants-wrapper')
			$($element).each(function() {
				var $this = $(this);
				var value = $('input:checked',$this).attr('value');
				$('.variants__label span',$this).html(value);
			});
		},
		updateMedia: function(variant) {
			if (variant && variant.featured_media && variant.featured_media.id) {
				$('.slick-carousel__item',selectors.EditVariantContainer).removeClass('show');
				$(selectors.EditVariantImages, selectors.EditVariantContainer).find('.edit_variant-images__item').each(function() {
					var imageID = $(this).data('media-id');
					if (variant.featured_media.id == imageID) {
						$(this).closest('.slick-carousel__item').addClass('show');
						var slickIndex = $(this).closest('.slick-carousel__item').data('slick-index');
						if (slickIndex !== undefined && slickIndex !== null) {
							$(selectors.EditVariantImages, selectors.EditVariantContainer).slick('slickGoTo', slickIndex);
						}
					}
				});
			}
		},

		updatePrice: function(variant) {
			var moneyFormat = window.money_format;
			if (!variant) {
				$(selectors.EditVariantProductPrice, selectors.EditVariantContainer).addClass('d-none');
				$(selectors.EditVariantProductPriceCompare, selectors.EditVariantContainer).addClass('d-none');
			} else {
				$(selectors.EditVariantProductPrice, selectors.EditVariantContainer).removeClass('d-none');
				$(selectors.EditVariantProductPriceCompare, selectors.EditVariantContainer).removeClass('d-none');
				$(selectors.EditVariantProductPrice, selectors.EditVariantContainer).html(
					smartaddons.Currency.formatMoney(variant.price, moneyFormat)
				);
				if (variant.compare_at_price > variant.price) {
					$(selectors.EditVariantProductPriceCompare, selectors.EditVariantContainer).html(
						smartaddons.Currency.formatMoney(variant.compare_at_price, moneyFormat)
					).removeClass('d-none');
					$(selectors.EditVariantProductPrice, selectors.EditVariantContainer).addClass('on-sale');
				} else {
					$(selectors.EditVariantProductPriceCompare, selectors.EditVariantContainer).addClass('d-none');
					$(selectors.EditVariantProductPrice, selectors.EditVariantContainer).removeClass('on-sale');
				}
			}
            if( $('.currency-Picker').length > 0){
                Currency.convertAll(window.shop_currency, jQuery('select[name=currencies] option:selected').val(), 'span.money', 'money_format');
            } 
		},

		updateProductAvaiable: function(variant) {
			var classActive = 'product-avaiable--active';
			var translations = window.strings;
			$(selectors.EditVariantAvaiable, selectors.EditVariantContainer).removeClass(classActive);
			if (variant) {
				if (variant.available) {
					$(selectors.EditVariantQty, selectors.EditVariantContainer).removeClass('d-none');
					$(selectors.EditVariantAvaiableInStock, selectors.EditVariantContainer).addClass(classActive);
				} else {
					$(selectors.EditVariantQty, selectors.EditVariantContainer).addClass('d-none');
					$(selectors.EditVariantAvaiableOutStock, selectors.EditVariantContainer).addClass(classActive);
				}
				// Button add to cart
				if (variant.available) {
					$(selectors.EditVariantContainer).find('.btn-ss-add-to-cart')
						.removeClass('disabled')
						.prop('disabled', false);
					$(selectors.EditVariantContainer).find('.btn-ss-add-to-cart .btn__text').html(translations.addToCart);
				} else {
					$(selectors.EditVariantContainer).find('.btn-ss-add-to-cart')
						.addClass('disabled')
						.prop('disabled', true);
					$(selectors.EditVariantContainer).find('.btn-ss-add-to-cart .btn__text').html(translations.soldOut);
				}
			} else {
				$(selectors.EditVariantQty, selectors.EditVariantContainer).addClass('d-none');
				$(selectors.EditVariantContainer).find('.btn-ss-add-to-cart')
					.addClass('disabled')
					.prop('disabled', true);
				$(selectors.EditVariantContainer).find('.btn-ss-add-to-cart .btn__text').html(translations.unavailable);
			}
		},

		updateDetailsLink: function(variant) {
			if (variant) {
				var productURL = $(selectors.EditVariantDetailsURL, selectors.EditVariantContainer).data('url') + '?variant=' + variant.id;
				$(selectors.EditVariantDetailsURL, selectors.EditVariantContainer).removeClass('d-none').attr('href', productURL);
			} else {
				$(selectors.EditVariantDetailsURL, selectors.EditVariantContainer).addClass('d-none');
			}
		},

		onVariantChange: function(id_variant) {
			var variant = this.getVariantFromOptions();
			if ($('[data-single-option-button]', selectors.EditVariantContainer).length) {
				this.updateVariantsButton();
				if (!variant || !variant.available) {
					this.updateVariantsButtonDisabed();
					return;
				}
			}
			setTimeout(function(){
				if (variant.id != id_variant){
					$('.btn-ss-add-to-cart',selectors.EditVariantContainer).prop('disabled', false);
				}else{
					$('.btn-ss-add-to-cart',selectors.EditVariantContainer).prop('disabled', true);
				}
			}, 100);
			this.updateMasterSelect(variant);
			this.updateLabelvariant(variant);
			this.updateMedia(variant);
			this.updatePrice(variant);
			this.updateProductAvaiable(variant);
			this.updateDetailsLink(variant);
			this.currentVariant = variant;
		}
	});
	return EditVariant;
})();    
    
// PRODUCT SECTION
smartaddonSS.Product = (function() {
	function Product(container) {
		var $window = $(window);
		var $container = (this.$container = $(container));
		var sectionId = $container.attr('data-section-id');
		this.settings = {
			productPageLoad: false,
			preloadImage: false,
			enableHistoryState: $container.data('enable-history-state'),
			namespace: '.productSection',
			sectionId: sectionId
		};
		this.selectors = {
			productMediaGroup: '.product-photo-container',
			productMediaGroupItem: '.js-product-media-item',
			productMediaWrapper: '.js-product-media',
			productMediaTypeModel: '[data-product-media-type-model]',
			productMediaTypeVideo: '[data-product-media-type-video]',
			productThumbnails: '.js-product-thumbnails',
			buyTogether: '.buy-together-products',
			productThumbnail: '[data-product-thumbnail]',
			productImageZoom: '[data-mfp-src]',
			meta: '.product-single__meta',
			productWrapper: '.product-single',
			productSelectOption: '.js-product-select-option--',
			originalSelectorId: '.js-product-select',
			singleOptionSelector: '.js-single-option-selector',
			slickDots: '[data-slick-dots]',
			slickNext: '[data-slick-next]',
			slickPrevious: '[data-slick-previous]',
			variantColor: '[data-color]',
		};
		this.classes = {
			hide: 'd-none',
			priceContainerUnitAvailable: 'price-container--unit-available',
			productInventoryInStock: 'product-avaiable__text--instock',
			productInventoryOutStock: 'product-avaiable__text--outstock',
		};
		this.productSingleObject = JSON.parse(
		  document.getElementById('ProductJson-' + sectionId).innerHTML
		);
		this.initProductVariant();
        this.ss_buyss_together();
        $("video").on('play', function() {
           $('.product-single__media.video').removeClass('play');
        });   
        $("video").on('pause', function() {
           $('.product-single__media.video').addClass('play');
        });      
    }
  Product.prototype = _.assignIn({}, Product.prototype, {
    initProductVariant: function() {
		var options = {
			$container: this.$container,
			enableHistoryState: this.settings.enableHistoryState || false,
			productSelectOption: this. selectors.productSelectOption,
			singleOptionSelector: this.selectors.singleOptionSelector,
			originalSelectorId: this.selectors.originalSelectorId + '--' + this.settings.sectionId,
			product: this.productSingleObject
		};
        
		var count = $(this.selectors.productThumbnails, this.$container).data('columns');
		this.variants = new smartaddonSS.Variants(options);
		var featured_media = this.variants.currentVariant.featured_media;
		if(!$('.js-product-single-media').hasClass('no-variants') && !$('.js-product-single-media >.row').hasClass('mutil_slider-single') && featured_media ){
			this.showVariantMedia(this.variants.currentVariant,true);
		}
		this.$container.on('variantChange' + this.settings.namespace,this.productPage.bind(this));
		this.$container.on('variantMediaChange' + this.settings.namespace,this.showVariantMedia.bind(this));
		if(this.variants.product.media.length <= count){
			$(this.selectors.productThumbnails, this.$container).addClass('no-transform');
		}
    },
    
    ss_buyss_together: function() {
        $(document).on('change', '#buyss_together_form .product-item input[type="checkbox"]', function (e) {
            var $this = $(this);
			if( $this.closest('.product-item').hasClass('active') ){
				$this.closest('.product-item').removeClass('active');
			}else{
				$this.closest('.product-item').addClass('active');
			}          
			var $thisWrap = $this.closest('.products-item-wrap');
			var $thisSSWrap = $thisWrap.closest('.ss-buytogether-products');
			var $thisProductsSSWrap = $thisSSWrap.find('.products-item-wrap');
			var total_items = 0;
			var total_price = 0;          

			$thisWrap.find('.product-item').each(function () {
				var this_product_id = $(this).attr('data-product_id');
				if ( $(this).hasClass('active') ) {
					$('input[type="hidden"]',$(this)).prop('disabled', false);
					$('input[type="number"]',$(this)).prop('disabled', false);
					if( $('select',$(this)).length > 0 ){
						var this_price = $('select',$(this)).find(':selected').data('price');
						$('select',$(this)).prop('disabled', false);
					}else{
						var this_price = $('input[type="checkbox"]',$(this)).attr('data-price');
					}
					if (!isNaN(this_price)) {
						total_price = Number(total_price) + Number(this_price);
					}
					Number(total_items++);
					$('.product-item-inner[data-product_id="' + this_product_id + '"]').removeClass('ss-buy-hidden');
				}
				else {
					$('.product-item-inner[data-product_id="' + this_product_id + '"]:not(.buy-together-content)').addClass('ss-buy-hidden');
					$('input[type="hidden"]',$(this)).prop('disabled', true);
					$('input[type="number"]',$(this)).prop('disabled', true);
					if( $('select',$(this)).length > 0 ){
						$('select',$(this)).prop('disabled', true);
					}
				}
			});
			$thisSSWrap.find('.number-items-text span').html(total_items);
			$thisSSWrap.find('.total-price span').html('<span class="money">'+ smartaddons.Currency.formatMoney(total_price,window.money_format) + '</span>');
            if( $('.currency-Picker').length > 0){
                Currency.convertAll(window.shop_currency, jQuery('select[name=currencies] option:selected').val(), 'span.money', 'money_format');
            }
        });

		$(document).on('change', '#buyss_together_form .product-item select', function (e) {
			var $this = $(this);
			var $thisWrap = $this.closest('.products-item-wrap');
			var $thisSSWrap = $thisWrap.closest('.ss-buytogether-products');
			var total_items = 0;
			var total_price = 0;
			var $parent = $(this).closest('.product-item');
			var this_product_id = $parent.attr('data-product_id');
			var $parent_image = $(this).closest('.ss-buytogether-products').find('.product-item-inner[data-product_id="' + this_product_id + '"]');
			var this_price_selected = $(this).find(':selected').data('price');
			var this_image_selected = $(this).find(':selected').data('image');
			$('.ss-buytogether-price',$parent).html('<span class="money">'+ smartaddons.Currency.formatMoney(this_price_selected,window.money_format) + '</span>');
            if(this_image_selected){
                $(".image img",$parent_image).attr("src", this_image_selected);
    			$(".image img",$parent_image).attr("srcset", this_image_selected);
            }
			$thisWrap.find('.product-item').each(function () {
				if ( $(this).hasClass('active') ) {
					if( $('select',$(this)).length > 0 ){
						var this_price = $('select',$(this)).find(':selected').data('price');
					}else{
						var this_price = $('input[type="checkbox"]',$(this)).attr('data-price');
					}
					if (!isNaN(this_price)) {
						total_price = Number(total_price) + Number(this_price);
					}
					Number(total_items++);
				}
			});
			$thisSSWrap.find('.total-price span').html('<span class="money">'+ smartaddons.Currency.formatMoney(total_price,window.money_format) + '</span>');
            if( $('.currency-Picker').length > 0){
                Currency.convertAll(window.shop_currency, jQuery('select[name=currencies] option:selected').val(), 'span.money', 'money_format');
            }
		});	
		$('#buyss_together_form .buy-together-add-all-to-cart').on('click',function(e){
			e.preventDefault();
			$(this).addClass('active');
			let addToCartForm = document.querySelector('#buyss_together_form');
			let formData = new FormData(addToCartForm);
			var params = {
				type: 'POST',
				url: '/cart/add.js',
				data: formData,
				processData: false,
				contentType: false,
				dataType: 'json',
				success: function(line_item) {
					$('.buy-together-add-all-to-cart').removeClass('active');
					document.location.href = '/cart';
				},
				error: function(XMLHttpRequest, textStatus) {
					if (typeof errorCallback === 'function') {
						errorCallback(XMLHttpRequest, textStatus);
					} else {
						ShopifyAPI.onError(XMLHttpRequest, textStatus);
					}
				}
			};
			jQuery.ajax(params);
		});
      
    },
    
    triggerMediaChangeEvent: function(mediaId) {
		var $otherMedia = $(this.selectors.productMediaWrapper, this.$container);
		$otherMedia.trigger('mediaHidden');
		var $newMedia = $(
			this.selectors.productMediaWrapper,
			this.$container
		).filter('[data-media-id="' + mediaId + '"]');
		$newMedia.trigger('mediaVisible');
    },
    
    showVariantMedia: function(evt,check) { 
       
		if(check){
			var variant = evt;
		}else{
			var variant = evt.variant;
		}
		var variantMediaId =
        this.settings.sectionId + '-' + variant.featured_media.id;
        
		var $newMedia = $(
			this.selectors.productMediaWrapper +
			'[data-media-id="' +
			variantMediaId +
			'"]'
		);
		this.triggerMediaChangeEvent(variantMediaId);   
		var mediaIndex;
		mediaIndex = $newMedia.closest('.slick-slide').data('slick-index');
		if (_.isUndefined(mediaIndex)) {
				return;
		}
       
		if (mediaIndex !== 0 || smartaddonSS.variables.productPageLoad) {
			$(this.selectors.productMediaGroup, this.$container).slick(
				'slickGoTo',
				mediaIndex
			);
		}
      
		if (!smartaddonSS.variables.productPageLoad) {
			smartaddonSS.variables.productPageLoad = true;
		}
    },    

    getBaseUnit: function(variant) {
		return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
            variant.unit_price_measurement.reference_unit;
    },

    productPage: function(evt) {
		var variant = evt.variant;
		var translations = window.trans_text;
        var moneyFormat = window.money_format;
		var selectors = {
			addToCart: '#AddToCart-product-template',
			addToCartText: '#AddToCart-product-template span',
			quantityElements: '.js-quantity-selector',
			shopifyPaymentButton: '.shopify-payment-button',
			priceContainer: '[data-price-container]',
			productPrice: '.ss-product-price',
            productTotalPrice: '.total-price span.money',
            productPriceFixed: '.add-to-cart-fixed .js-product-price',
			comparePrice: '.ss-product-compare-price',
			comparePriceWrapper: '.product-single__price--wrapper',
            comparePriceFixed: '.add-to-cart-fixed .js-product-compare-price',
			productAvailable: '.js-product-avaiable',
			productAvailableText: '.js-product-avaiable-text',
			unitPrice: '[data-unit-price]',
			unitPriceBaseUnit: '[data-unit-price-base-unit]',
			SKU: '.js-variant-sku'
		};
		if (variant) {
			$(selectors.priceContainer, this.$container).removeClass(this.classes.hide);
			$(selectors.productAvailable, this.$container).removeClass(this.classes.hide);
			$(selectors.productPrice, this.$container).attr('aria-hidden', 'false');
			if (variant.available) {
				$(selectors.addToCart, this.$container).removeClass('disabled').prop('disabled', false);         
				$(selectors.addToCartText, this.$container).html(translations.addToCart);
				$(selectors.productAvailableText)
					.removeClass(this.classes.productInventoryOutStock)
					.addClass(this.classes.productInventoryInStock)
					.html(window.trans_text.in_stock);
			$(selectors.quantityElements, this.$container).removeClass(this.classes.hide);
			$(selectors.shopifyPaymentButton, this.$container).removeClass(this.classes.hide);
			} else {
				$(selectors.addToCart, this.$container).addClass('disabled').prop('disabled', true);
				$(selectors.addToCartText, this.$container).html(translations.soldOut);
				$(selectors.productAvailableText)
					.removeClass(this.classes.productInventoryInStock)
					.addClass(this.classes.productInventoryOutStock)
					.html(window.trans_text.out_of_stock);
				$(selectors.quantityElements, this.$container).addClass(this.classes.hide);
				$(selectors.shopifyPaymentButton, this.$container).addClass(this.classes.hide);
			}

			$(selectors.productPrice, this.$container).html(smartaddons.Currency.formatMoney(variant.price , moneyFormat)).removeClass(this.classes.hide);
            $(selectors.productTotalPrice, this.$container).html(smartaddons.Currency.formatMoney(variant.price , moneyFormat)).removeClass(this.classes.hide);
            $(selectors.productPriceFixed).html(smartaddons.Currency.formatMoney(variant.price , moneyFormat)).removeClass(this.classes.hide);
			if (variant.compare_at_price > variant.price) {
				$price_pecent = parseInt((variant.price - variant.compare_at_price)*100/variant.compare_at_price);
                 $(".product-card__label .product-card__on-sale", this.$container).html($price_pecent+'%');
				$(selectors.comparePrice, this.$container).html(smartaddons.Currency.formatMoney(variant.compare_at_price , moneyFormat));
				$(selectors.comparePriceWrapper, this.$container).removeClass(this.classes.hide);
				$(selectors.productPrice, this.$container).addClass('on-sale');
				$(selectors.comparePriceWrapper, this.$container).attr('aria-hidden', 'false');
                $(selectors.comparePriceFixed).html(smartaddons.Currency.formatMoney(variant.compare_at_price , moneyFormat));
			} else {
				$(selectors.comparePriceWrapper, this.$container).addClass(this.classes.hide).attr('aria-hidden', 'true');
				$(selectors.productPrice, this.$container).removeClass('on-sale');
				$(selectors.comparePrice, this.$container).html('');
                $(selectors.comparePriceFixed).html('');
			}

			if (variant.unit_price) {
				var $unitPrice = $(selectors.unitPrice, this.$container);
				var $unitPriceBaseUnit = $(
					selectors.unitPriceBaseUnit,
					this.$container
				);
				$unitPrice.html( smartaddons.Currency.formatMoney(variant.compare_at_price , moneyFormat));
				$unitPriceBaseUnit.html(this.getBaseUnit(variant));
				$(selectors.priceContainer, this.$container).addClass(this.classes.priceContainerUnitAvailable);
			}
			$(selectors.SKU).html(variant.sku != '' ? variant.sku : 'N/A');
       
		} else {
			$(selectors.addToCart, this.$container).addClass('disabled').prop('disabled', true);
			$(selectors.addToCartText, this.$container).html(translations.unavailable);
			$(selectors.quantityElements, this.$container).addClass(this.classes.hide);
			$(selectors.shopifyPaymentButton, this.$container).addClass(this.classes.hide);
			$(selectors.priceContainer, this.$container).addClass(this.classes.hide);
			$(selectors.productAvailable, this.$container).addClass(this.classes.hide);
			$(selectors.productPrice, this.$container).attr('aria-hidden', 'true');
			$(selectors.comparePriceWrapper, this.$container).attr('aria-hidden', 'true');
		}
    },
  });
  return Product;
})(); 
    
smartaddonSS.Variants = (function() {
    function Variants(options) {
      this.$container = options.$container;
      this.product = options.product;
      this.productSelectOption = options.productSelectOption;
      this.singleOptionSelector = options.singleOptionSelector;
      this.originalSelectorId = options.originalSelectorId;
      this.enableHistoryState = options.enableHistoryState;
      this.currentVariant = this._getVariantFromOptions();
      $(this.singleOptionSelector, this.$container).on(
  		'change',this._onSelectChange.bind(this)
      );
    }
  
    Variants.prototype = _.assignIn({}, Variants.prototype, {
      _getCurrentOptions: function() {
  		var currentOptions = _.map(
  			$(this.singleOptionSelector, this.$container),
  			function(element) {
  				var $element = $(element);
  				var type = $element.attr('type');
  				var currentOption = {};
  				if (type === 'radio' || type === 'checkbox') {
  					if ($element[0].checked) {
  						currentOption.value = $element.val();
  						currentOption.index = $element.data('index');
  						return currentOption;
  					} else {
  						return false;
  					}
  				} else {
  					currentOption.value = $element.val();
  					currentOption.index = $element.data('index');
  					return currentOption;
  				}
  			}
  		);
  		currentOptions = _.compact(currentOptions);
  		return currentOptions;
      },
  
      _getVariantFromOptions: function() {
  		var selectedValues = this._getCurrentOptions();
  		var variants = this.product.variants;
  		var found = _.find(variants, function(variant) {
  			return selectedValues.every(function(values) {
  				return _.isEqual(variant[values.index], values.value);
  			});
  		});
  		return found;
      },
  
      _onSelectChange: function() {
  		var variant = this._getVariantFromOptions();
        
  		if ($('[data-single-option-button]', this.$container).length && $('.color-select', this.$container).length < 1 ) {
  			this._updateVariantsButton();
  			if (!variant || !variant.available) {
  				this._updateVariantsButtonDisabed();
  				return;
  			}
  		}
  		this.$container.trigger({
  			type: 'variantChange',
  			variant: variant
  		});
  		if (!variant) return;
  		this._updateMasterSelect(variant);
  		this._updateMedia(variant);
  		this._updatePrice(variant);
  		this._updateQuantity(variant);
  		this._updateOption(variant);
  		this._updatePricesticky(variant);
  		this._updateSKU(variant);
  		this._updateLabelvariant(variant);
  		this.currentVariant = variant;
  		this._updatePickUp(variant);
  		this._updateBtnText(variant);
  		this._updateDelivery(variant);
  		if (this.enableHistoryState) {
  			this._updateHistoryState(variant);
  		}
      },
  
      _updateVariantsButtonDisabed: function() {
  		for (var i = 2; i <= 3; i++) {
  			if ($(this.productSelectOption + i, this.$container).length) {
  				var isUpdate = false;
  				$(this.productSelectOption + i + ' ' + this.singleOptionSelector, this.$container).each(function() {
  					var $element = $(this);
  					var type = $element.attr('type');
  					if (type === 'radio' || type === 'checkbox') {
  						if (this.checked && $element.hasClass('disabled')) {
  							$element.prop('checked', false);
  							isUpdate = true;
  							return false;
  						}
  					}
  				});
  				$(this.productSelectOption + i + ' ' + this.singleOptionSelector, this.$container).each(function() {
  					var $element = $(this);
  					var type = $element.attr('type');
  					if (isUpdate && (type === 'radio' || type === 'checkbox') && !$element.hasClass('disabled')) {
  						$element.prop('checked', true);
  						isUpdate = false;
  						$element.trigger('change');
  						return false;
  					}
  				});
  			}
  		}
      },
  
      _updateVariantsButton: function() {
  		var selectedValues = this._getCurrentOptions();
  		var variants = this.product.variants;
  		for (var i = 2; i <= 3; i++) {
  			if ($(this.productSelectOption + i, this.$container).length) {
  				var $parent = this.productSelectOption + i;
  				$($parent + ' ' + this.singleOptionSelector, this.$container).each(function() {
  					var $self = $(this);
  					var optionValue = $self.val();
  					var foundIndex;
  					if (i === 2) {
  						foundIndex = _.findIndex(variants, function(variant) {
  							variant.option1 = variant.option1.toString();
  							selectedValues[0].value = selectedValues[0].value.toString();
  							variant.option2 = variant.option2.toString();
  							optionValue = optionValue.toString();
  							return variant.option1 === selectedValues[0].value &&
  							variant.option2 === optionValue &&
  							variant.available === true;
  						});
  						
  					} else if (i === 3) {
  						foundIndex = _.findIndex(variants, function(variant) {
  							variant.option1 = variant.option1.toString();
  							variant.option2 = variant.option2.toString();
  							variant.option3 = variant.option3.toString();
  							selectedValues[0].value = selectedValues[0].value.toString();
  							selectedValues[1].value = selectedValues[1].value.toString();
  							optionValue = optionValue.toString();
  							return variant.option1 === selectedValues[0].value && variant.option2 === selectedValues[1].value &&
  							variant.option3 === optionValue &&
  							variant.available === true;
  						});
  					}
  					if (foundIndex !== -1) {
  						if ($($parent +'.color-select', this.$container).length > 0) {
  							$self.removeClass('disabled');
  							$self.next('label').removeClass('disabled');
  						}else{
  							$self.removeAttr('disabled', 'disabled').removeClass('disabled');
  							$self.next('label').removeClass('disabled');
  						}
  						
  					} else {
  						if ($($parent +'.color-select', this.$container).length  > 0) {
  							$self.addClass('disabled');
  							$self.next('label').addClass('disabled');
  						}else{
  							$self.attr('disabled', 'disabled').addClass('disabled');
  							$self.next('label').addClass('disabled');
  						}
  					}
  				});
  			}
  		}
      },
  
      _updateMedia: function(variant) {
  		var variantMedia = variant.featured_media || {};
  		var currentVariantMedia = this.currentVariant.featured_media || {};
  		var isMatchingPreviewImage = false;
        
  		if (variantMedia.preview_image && currentVariantMedia.preview_image) {
  			isMatchingPreviewImage = variantMedia.preview_image.src === currentVariantMedia.preview_image.src;
  		}
        
  		if (!variant.featured_media || isMatchingPreviewImage) return;
  		this.$container.trigger({
  			type: 'variantMediaChange',
  			variant: variant
  		});
      },
  
      _updatePrice: function(variant) {
        if( $('.currency-Picker').length > 0){
            Currency.convertAll(window.shop_currency, jQuery('select[name=currencies] option:selected').val(), 'span.money', 'money_format');
        }
  		if (
  			variant.price === this.currentVariant.price &&
  			variant.compare_at_price === this.currentVariant.compare_at_price
  		){
  			return;
  		}
  		this.$container.trigger({
  			type: 'variantPriceChange',
  			variant: variant
  		});
      },
  	
  	_updateQuantity: function(variant){
  		if( $(".product-single .content-variant_inventory").length > 0 ){
  			setTimeout(function(){ 
              $( ".product-single .content-variant_inventory" ).load(window.location.href + ".content-variant_inventory .js-product-avaiable" ); 
            }, 10);
  		}
        $('#qty , .quantity-selector').val(1);
  	},
  	
  	_updateOption: function(){ 
  		setTimeout(function(){ $( "#option-selector" ).load(window.location.href + " #option-selector" ); }, 10);
  	},
  	
  	_updatePricesticky: function(){ 
  		setTimeout(function(){ $( "#price-sticky" ).load(window.location.href + " #price-sticky" ); }, 10);
  	},
  	
    _updateSKU: function(variant) {
  		if (variant.sku === this.currentVariant.sku) {
  			return;
  		}
  		$('.product-single__type_sku').html('');
        $('.product-single__type_sku').append(variant.sku);
        console.log(variant.sku);
        if(variant.sku == null) {
          $('.product-single__type_sku').parent().addClass('hidden');
        } else {
          $('.product-single__type_sku').parent().removeClass('hidden');
        }
    },
  	_updateLabelvariant: function(variant) {
  		var $element = $('.product-single .product-form .variants-wrapper')
  		$('.mutil_slider-single').removeClass('active');
  		$($element).each(function() {
  			var $this = $(this);
  			if( $("select",$this).length > 0 ){
  				var value = $( "select",$this).find(':selected').val();
  			}else{
  				var value = $('input:checked',$this).attr('value');
  			}
  			$('.variants__label span',$this).html(value);
  			$('.mutil_slider-single.'+ value +'').addClass('active');
  		});
      },
      _updateHistoryState: function(variant) {
  		if (!history.replaceState || !variant) {
  			return;
  		}
  		var newurl =
  			window.location.protocol +
  			'//' +
  			window.location.host +
  			window.location.pathname +
  			'?variant=' +
  			variant.id;
  		window.history.replaceState({path: newurl},'',newurl
  		);
  		if( $(".product-single #buy_more_form").length > 0 ){
  			$('#buy_more_form input[name="items[][id]"]').attr('value',variant.id);
  			smartaddonSS.discount_single();
  		}
      },
  	
  	_updatePickUp: function(variant) {
  		if( $(".product-single .product-single__pick_up").length > 0 ){
  			$('.product-single .product-single__pick_up').addClass('load-pick_up').css("height", $('.product-single .product-single__pick_up').height() + 'px');
  			$(".product-single .product-single__pick_up").empty();
  			smartaddonSS.pick_up(variant.id);
  			setTimeout(function(){
  				$('.product-single .product-single__pick_up').removeClass('load-pick_up').removeAttr('style');
  			}, 1000);
  		}
      },
  	_updateBtnText: function(variant) {
  		if( $(".template-product .product-options-bottom .product-form__item--submit .btn__text span").length > 0 ){
  			setTimeout(function(){ $( ".template-product .product-options-bottom .product-form__item--submit .btn__text" ).load(window.location.href + ".product-options-bottom .product-form__item--submit .btn__text span" ); }, 10);
  		}
  		if( $(".add-to-cart-fixed").length > 0 ){
  			setTimeout(function(){ $( ".add-to-cart-fixed .button-addtocard .btn__text" ).load(window.location.href + ".add-to-cart-fixed .button-addtocard .btn__text span" ); }, 10);
  		}
      },
  	_updateDelivery: function(variant) {
  		if( $(".product-single .estimated_delivery").length > 0 && $(".product-single .section-estimated_delivery[data-incoming]").length > 0 ){
  			$('.product-single .section-estimated_delivery').addClass('load-delivery').css("height", $('.product-single .section-estimated_delivery').height() + 'px');
  			setTimeout(function(){
  				$( ".product-single .section-estimated_delivery" ).load(window.location.href + ".product-single .estimated_delivery" );				
  			}, 10);
  			setTimeout(function(){
  				if( $(".product-single .time_hour").length > 0 ){
  					smartaddonSS.time_estimated_delivery();
  				}
  			}, 1200);
  			setTimeout(function(){
  				if( $(".product-single .time_hour").length > 0 ){
  					$('.product-single .section-estimated_delivery').removeClass('load-delivery').removeAttr('style');
  				}
  			}, 1400);
  		}
      },
      _updateMasterSelect: function(variant) {
  		$(this.originalSelectorId, this.$container).val(variant.id);
      }
    });
  
    return Variants;
  })();
    
  
  smartaddonSS.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];
  };
  
  smartaddonSS.Sections.prototype = _.assignIn({}, smartaddonSS.Sections.prototype, {
    _createInstance: function(container, constructor) {
      var $container = $(container);
      var id = $container.attr('data-section-id');
      var type = $container.attr('data-section-type');
      constructor = constructor || this.constructors[type];
      if (_.isUndefined(constructor)) {
        return;
      }
      var instance = _.assignIn(new constructor(container), {
        id: id,
        type: type,
        container: container
      });
      this.instances.push(instance);
    },
  
    _onSectionLoad: function(evt) {
      var container = $('[data-section-id]', evt.target)[0];
      if (container) {
        this._createInstance(container);
      }
    },
  
    _onSectionUnload: function(evt) {
      this.instances = _.filter(this.instances, function(instance) {
        var isEventInstance = instance.id === evt.originalEvent.detail.sectionId;
        if (isEventInstance) {
          if (_.isFunction(instance.onUnload)) {
            instance.onUnload(evt);
          }
        }
        return !isEventInstance;
      });
    },
  
    _onSelect: function(evt) {
      var instance = _.find(this.instances, function(instance) {
        return instance.id === evt.originalEvent.detail.sectionId;
      });
      if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
        instance.onSelect(evt);
      }
    },
  
    _onDeselect: function(evt) {
      var instance = _.find(this.instances, function(instance) {
        return instance.id === evt.originalEvent.detail.sectionId;
      });
      if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
        instance.onDeselect(evt);
      }
    },
  
    _onBlockSelect: function(evt) {
      var instance = _.find(this.instances, function(instance) {
        return instance.id === evt.originalEvent.detail.sectionId;
      });
      if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
        instance.onBlockSelect(evt);
      }
    },
  
    _onBlockDeselect: function(evt) {
      var instance = _.find(this.instances, function(instance) {
        return instance.id === evt.originalEvent.detail.sectionId;
      });
      if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
        instance.onBlockDeselect(evt);
      }
    },
  
    register: function(type, constructor) {
      this.constructors[type] = constructor;
      $('[data-section-type=' + type + ']').each(
        function(index, container) {
          this._createInstance(container, constructor);
        }.bind(this)
      );
    }
  });      

  smartaddonSS.variables = {
        productPageLoad: false,
        productPageSticky: true,
        mediaTablet: 'screen and (max-width: 1024px)',
        mediaMobile: 'screen and (max-width: 767px)',
        isTablet: false,
        isMobile: false
 };    
 // Pick UP
      smartaddonSS.pick_up = function(id) {
      	if( $(".product-single .product-single__pick_up").length > 0 ){
      		var $element = $('.product-single .product-single__pick_up'),
      			title = $element.data('product_title'),
      			image_url = $element.data('src');
      		if(id == null){
      			var id = $element.data('id');
      		}
      		fetch(window.Shopify.routes.root + "variants/"+id+"/?section_id=pickup-availability").then(response => response.text()).then(text => {
      			const container = document.querySelector('[data-store-availability-container]');
      			const pickupAvailabilityHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('.shopify-section');
      			container.appendChild(pickupAvailabilityHTML);
      			$(".product-info .title",$element).html(title);
      			if($element.data('only_variant') == true){
      				$(".product-info .product-image img",$element).attr('src',image_url);
      			}
      			$(".pickup-availability-info",$element).on( "click", function() {
      				if(!$(".pickup-availabilities-modal",$element).hasClass('active')){
      					$(".pickup-availabilities-modal",$element).addClass('active');
                        $( ".product__info-media" ).css("position","relative");
                        $( ".product__info-container" ).css("position","relative"); 
                        $("body").addClass('overflow_hidden');                      
      				}
      			});
      			$(".pickup_close",$element).on( "click", function() {
      				if($(".pickup-availabilities-modal",$element).hasClass('active')){
      					$(".pickup-availabilities-modal",$element).removeClass('active');
                        $("body").removeClass('overflow_hidden');           
      				}
      			});
      		})
      		.catch(e => {
      			console.error(e);
      		});
      	}
      }
    smartaddonSS.setCookie = function(cname, cvalue, exdays) {
    	var d = new Date();
    	d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    	var expires = 'expires=' + d.toGMTString();
    	document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    };      
    smartaddonSS.getCookie = function(cname) {
    	var name = cname + '=';
    	var decodedCookie = decodeURIComponent(document.cookie);
    	var cookieArray = decodedCookie.split(';');
    	for(var i = 0; i < cookieArray.length; i++) {
    		var cookieItem = cookieArray[i];
    		while (cookieItem.charAt(0) === ' ') {
    			cookieItem = cookieItem.substring(1);
    		}
    		if (cookieItem.indexOf(name) === 0) {
    			return cookieItem.substring(name.length, cookieItem.length);
    		}
    	}
    	return '';
    };

    if (typeof ShopifyAPI === 'undefined') {
    	ShopifyAPI = {};
    }

    ShopifyAPI.getCart = function(callback, added) {
      jQuery.getJSON('/cart.js', function(cart) {
        if (typeof callback === 'function') {
          callback(cart, added);
        }
      });
    };
    
    ShopifyAPI.onError = function(XMLHttpRequest) {
    	var data = eval('(' + XMLHttpRequest.responseText + ')');
    	if (data.message) {
    		alert(data.message + '(' + data.status + '): ' + data.description);
    	}
    };
    
    ShopifyAPI.attributeToString = function(attribute) {
    	if (typeof attribute !== 'string') {
    		attribute += '';
    		if (attribute === 'undefined') {
    			attribute = '';
    		}
    	}
    	return jQuery.trim(attribute);
    }
    
    ShopifyAPI.updateCartNote = function(note, callback) {
    	var params = {
    		type: 'POST',
    		url: '/cart/update.js',
    		data: 'note=' + ShopifyAPI.attributeToString(note),
    		dataType: 'json',
    		success: function(cart) {
    			if (typeof callback === 'function') {
    				callback(cart);
    			}
    		},
    		error: function(XMLHttpRequest, textStatus) {
    			ShopifyAPI.onError(XMLHttpRequest, textStatus);
    		}
    	};
    	jQuery.ajax(params);
    };
   
    ShopifyAPI.changeItem = function(line, quantity,modal,callback) {      
    	var params = {
    		type: 'POST',
    		url: '/cart/change.js',
    		data: 'quantity=' + quantity + '&line=' + line,
    		dataType: 'json',
    		success: function(cart) {
    			if(modal){
    				var id = $('.pu-cart input[data-modal-variant]').val();
    				for (var j in cart.items) {
    					if( id == cart.items[j].variant_id ){
    						var price = cart.items[j].price;
                            var final_line_price = cart.items[j].final_line_price;
                            var quantity = cart.items[j].quantity;
    					}
    				}
                    cartTotal = $('.pu-cart').find('.cart-popup-total').data('itemtotal');
                    TextCartTotal = cartTotal.replace(/\{itemsTotal\}/g, cart.item_count);
                    $('.pu-cart').find('.cart-popup-total').html(TextCartTotal);                  
                    $('.pu-cart').find('.cart-price-total .price-total').html(quantity);
                    $('.pu-cart').find('.cart-price-total .price-new').html(Shopify.formatMoney(price, window.money_format));
                    $('.pu-cart').find('.previewCartCheckout-price').html(Shopify.formatMoney(final_line_price, window.money_format));
                    updateToolsCart();
    			}
                updateMiniCart();
                if( $('.currency-Picker').length > 0){
                    Currency.convertAll(window.shop_currency, jQuery('select[name=currencies] option:selected').val(), 'span.money', 'money_format');
                }              
    		},
    		error: function(XMLHttpRequest, textStatus) {
    			ShopifyAPI.onError(XMLHttpRequest, textStatus);
    		}
    	};
    	jQuery.ajax(params);
    };       
    
    cartModalupdate= function() {
		$('.popup_cart .cart-popup-info input').change(function() {
			$('.popup_cart .cart-modal__middle').addClass('load_modal');
			var id = $('.popup_cart input[data-modal-variant]').val();
			var qty = $('.popup_cart .cart-popup-info input[name=quantity]').val(); 
            if(qty == 0) {
               qty = 1;
            }
			var modal = true;
			var count = $('#count_quantity [data-variant_id="'+id+'"]').data('count_quantity');
            
            jQuery.getJSON('/cart.js', function(cart) {
    			for (var j in cart.items) {
    				if( id == cart.items[j].variant_id ){
    					var line = parseInt(j) + 1;
    				}
    			}
                ShopifyAPI.changeItem(line, qty,modal);
            });
		});      
    }
  
    smartaddonSS.click_atribute_image= function() {  

        $(".add-sellect").on( "click", function() {
            var $element = $(this);	
            if($element.hasClass('add-sellect')) {
              $element.parent().parent().find('.ss-variants-swatch').addClass('bounce2');
              setTimeout(function() { 
                 $element.parent().parent().find('.ss-variants-swatch').removeClass('bounce2');
              }, 2000);                  
            }      
        });
      
    	$('.ss-variants-swatch').each(function() {
    		var $element = $(this);	
    		$(".swatch-items",$element).on( "click", function() {
    			var $this = $(this);
    			if(!$(this).hasClass("active")){
    				var $parent = $(this).closest(".swatch-content");
    				$(".swatch-items",$parent).removeClass("active");
    				$(this).addClass("active");
    				var variants_value = get_variant_value($element);
    				var productHandle = $element.data('handle');  

    				$.getJSON('/products/' + productHandle + '.js', function(product) {
    					if(product.variants){
    						updateVariantsButton($element,product);
    						$.each( product.variants, function( index, variant ){
    							if (variant.available) {
    								if(variant.title == variants_value){             
    									var $current =  $this.closest(".product-card");    
    									if(variant.compare_at_price){
    										$price_pecent = parseInt((variant.price - variant.compare_at_price)*100/variant.compare_at_price);
    										 $(".product-card__label .product-card__on-sale",$current).html($price_pecent+'%');
    										 $(".product-group-price[data-handle="+productHandle+"] .product-price--regular",$current).html(Shopify.formatMoney(variant.compare_at_price, window.money_format));
    									     $(".ss-buytogether-products [data-product_id="+product.id+"] .ss-buytogether-price-compare").html(Shopify.formatMoney(variant.compare_at_price, window.money_format));
                                        }
                                        $(".ss-buytogether-products [data-product_id="+product.id+"] .ss-buytogether-price").attr('data-price', variant.price);
                                        $(".ss-buytogether-products [data-product_id="+product.id+"] .ss-buytogether-price").html(Shopify.formatMoney(variant.price, window.money_format));
                                        $(".ss-buytogether-products [data-product_id="+product.id+"] input.item-id").val(variant.id);
                                        buys_together_home();
                                      
    									$(".product-group-price[data-handle="+productHandle+"] .variant-price",$current).html(Shopify.formatMoney(variant.price, window.money_format));
    									$(".product-card__form[data-handle="+productHandle+"] input[name='id']",$current).val(variant.id);
                                		if( $('.currency-Picker').length > 0){
                                          Currency.convertAll(window.shop_currency, jQuery('select[name=currencies] option:selected').val(), 'span.money', 'money_format');
                                        }

                                        $('.right-block .button-link input[name=id]',$current).val(variant.id);
                                        $('.right-block .button-link a',$current).addClass('btn-addToCart');
                                        $('.right-block .button-link a',$current).attr('href','javascript:void(0)');   
                                        $('.right-block .button-link a span',$current).html(window.trans_text.add_to_cart);
                                        $('.right-block .btn-button',$current).removeClass('add-sellect');
                                    	$('.pre_order-cart >span').each(function(){
                                    		var id = $(this).data('handle');
                                    		if(variant.id == id) {
                                    			$('.right-block .button-link a span',$current).html(window.variantStrings.preOrder);
                                    		}
                                    	});
    									if(variant.featured_media){
    										prodImg = variant.featured_media.preview_image.src.replace(/(\.[^.]*)$/, '_600x$1').replace('http:', '');
    										if($('.product-card__image-wrapper',$current).hasClass('slider')){
    											var variant_slick = $('.product-card__image-wrapper .product-card__image-link[data-variant_id="'+variant.featured_media.id+'"]',$current).data('slick-index');
    											$('.product-card__image',$current).slick('slickGoTo',variant_slick);
    										}else{
    											$(".product-card__image img.variant",$current).attr("src", prodImg);
    											$(".product-card__image img.variant",$current).attr("srcset", prodImg);
    										}

                                            $(".product-image-container img.img1",$current).attr("src", prodImg);  
    										if($('.product-card__image-wrapper',$current).hasClass('zoom')){
    											$(".product-card__image img",$current).last().attr("src", prodImg);
    										}
    										$(".product-card__image_compare[data-handle="+productHandle+"] img",".content-compare.active").attr("src", prodImg);
    										$(".product-card__image_compare[data-handle="+productHandle+"] img",".content-compare.active").attr("srcset", prodImg);
    									}
    								}
    							}
    						});
    					}
    				});
    			}
    		});
    	});
    },

    initProductVariant= function() {
		var options = {
			$container: this.$container,
			enableHistoryState: this.settings.enableHistoryState || false,
			productSelectOption: this. selectors.productSelectOption,
			singleOptionSelector: this.selectors.singleOptionSelector,
			originalSelectorId: this.selectors.originalSelectorId + '--' + this.settings.sectionId,
			product: this.productSingleObject
		};
		var count = $(this.selectors.productThumbnails, this.$container).data('columns');
		this.variants = new smartaddonSS.Variants(options);
		var featured_media = this.variants.currentVariant.featured_media;
		if(!$('.js-product-single-media').hasClass('no-variants') && !$('.js-product-single-media >.row').hasClass('mutil_slider-single') && featured_media ){
			this.showVariantMedia(this.variants.currentVariant,true);
		}
		this.$container.on('variantChange' + this.settings.namespace,this.productPage.bind(this));
		this.$container.on('variantMediaChange' + this.settings.namespace,this.showVariantMedia.bind(this));
		if(this.variants.product.media.length <= count){
			$(this.selectors.productThumbnails, this.$container).addClass('no-transform');
		}
    },

      
    get_variant_value= function($element) {
    	var variant1,variant2,variant3;
    	$('.swatch-content-1',$element).each(function(index) {
    		var value = $(".swatch-items.active label",$(this)).data("variant");
    		if(value === null){
    			value = "null";
    		}
    		variant1 = value;
    	});
    	$('.swatch-content-2',$element).each(function(index) {
    		var value = $(".swatch-items.active label",$(this)).data("variant");
    		if(value === null){
    			value = "null";
    		}
    		variant2 = value;
    	});
    	$('.swatch-content-3',$element).each(function(index) {
    		var value = $(".swatch-items.active label",$(this)).data("variant");
    		if(value === null){
    			value = "null";
    		}
    		variant3 = value;
    	});
    	if(variant1 && variant2 && variant3){
    		var variants_value = variant1 + ' / ' + variant2 + ' / ' + variant3;
    	}else if(variant1 && variant2){
    		var variants_value = variant1 + ' / ' + variant2;
    	}else if(variant1){
    		var variants_value = variant1;
    	}
    	return variants_value;
    },
    updateVariantsButton= function($element,$product) {
    	var selectedValues = getCurrentOptionsProduct($element);  
    	var variants = $product.variants;
    	for (var i = 2; i <= 3; i++) {
    		if ($(".swatch-content-"+i+"",$element).length) {
    			var $container = $(".swatch-content-"+i+"",$element);
    			$("label", $container).each(function() {
    				var $self = $(this);
    				var optionValue = $self.data("variant");
    				var foundIndex;
    				if (i === 2) {
                    	foundIndex = _.findIndex(variants, function(variant) {
                    		variant.option1 = variant.option1.toString();           
                            if(_.isUndefined(selectedValues[0])) {
                              return;
                            }
                    		selectedValues[0].value = selectedValues[0].value.toString();
                    		variant.option2 = variant.option2.toString();
                    		optionValue = optionValue.toString();
                    		return variant.option1 === selectedValues[0].value &&
                    		variant.option2 === optionValue &&
                    		variant.available === true;
                    	});
                    	
                    } else if (i === 3) {
                    	foundIndex = _.findIndex(variants, function(variant) {
                    		variant.option1 = variant.option1.toString();
                    		variant.option2 = variant.option2.toString();
                    		variant.option3 = variant.option3.toString();
                    		selectedValues[0].value = selectedValues[0].value.toString();
                    		selectedValues[1].value = selectedValues[1].value.toString();
                    		optionValue = optionValue.toString();
                    		return variant.option1 === selectedValues[0].value && variant.option2 === selectedValues[1].value &&
                    		variant.option3 === optionValue &&
                    		variant.available === true;
                    	});
                    }
                    
    				if (foundIndex !== -1) {
    					$self.closest(".swatch-items").removeClass('disabled');
    				} else {
    					$self.closest(".swatch-items").addClass('disabled');
    				}
    			});	
    		}
    	}
    },
     getCurrentOptionsProduct= function($element) {
    	var currentOptions = [];
    	for (var i = 1; i <= 3; i++) {
    		if ($(".swatch-content-"+i+"",$element).length) {
    			var currentOption = {};
    			currentOption.index = $(".swatch-content-"+i+" .swatch-items.active label",$element).data("index");
    			var $variant = $(".swatch-content-"+i+" .swatch-items.active label",$element).data("variant");
    			if($variant === null){
    				$variant = "null";
    			}		
    			currentOption.value = $variant;
    			currentOptions[i] = currentOption;
    		}
    	}
    	return _.compact(currentOptions);
    },
    initpopupVideo= function(){
      var popupVideo = $('.btn_videos');
      popupVideo.YouTubePopUp();
    },
    initCountd= function() {
      $('[data-date]').each(function() {
        var $this = $(this), 
            finalType = $(this).data('type'),
            finalDate = $(this).data('date');
        $this.countdown(finalDate, function(event) {   
          if(event.type != "finish") {
            if(finalType && finalType == "home-section") {
              $this.html(event.strftime('<div class="deals-time day"><div class="num-time">%D</div><div class="title-time">'+window.trans_text.days+'</div></div><div class="deals-time hour"><div class="num-time">%H</div><div class="title-time">'+window.trans_text.hours+'</div></div><div class="deals-time minute"><div class="num-time">%M</div><div class="title-time">'+window.trans_text.minutes+'</div></div><div class="deals-time second"><div class="num-time">%S</div><div class="title-time">'+window.trans_text.seconds+'</div></div>'));
            } else {
              $this.html(event.strftime('<div class="deals-time day"><div class="num-time">%D</div><div class="title-time">D</div></div><div class="deals-time hour"><div class="num-time">%H</div><div class="title-time">H</div></div><div class="deals-time minute"><div class="num-time">%M</div><div class="title-time">M</div></div><div class="deals-time second"><div class="num-time">%S</div><div class="title-time">S</div></div>'));
            } 
          
          } else {
            $(this).parent('.countdown_tab').hide();
            $(this).parent().parent('.product-countdown').hide();
          }          
        });
      }); 
    },
     initInstaGram= function(){
      $(".instagram .instagram-slide").each(function(){
        var instagramFeed = $(this);
        var insId = instagramFeed.data("id"),
            insUserId = instagramFeed.data("userid"),
            insAccessToken = instagramFeed.data("accesstoken"),
            insLimited = instagramFeed.data("limit"),
            insResolution = instagramFeed.data("resolution"),
            insNav = instagramFeed.data("navigation");

        var feed = new Instafeed({
          get: 'user',
          userId: insUserId,
          accessToken: insAccessToken,
          target: insId,
          limit: insLimited,
          resolution: insResolution,
          template: '<a class="item-in col-4" target="_blank" href="{{link}}" title="{{caption}}"><img class="img-responsive lazyload" data-sizes="auto" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" alt="{{caption}}" data-src="{{image}}" /><span class="ss_likes d-none">{{likes}}</span></a>',
          before: function() {},
          after: function() {

          },
          success: function() {},
          error: function() {}
        });

        feed.run();
      });
    },
    initlOwlCarouselAfer= function() {
      $(".ss-owl-after .owl-carousel").each(function(){
        var owlCarousel = $(this);
        var nav 		= owlCarousel.data("nav"),
            dots		= owlCarousel.data("dots"),
            autoplay 	= owlCarousel.data("autoplay"),
            loop 		= owlCarousel.data("loop"),
            autowidth 	= owlCarousel.data("autowidth"),
            autospeed 	= owlCarousel.data("autospeed"),
            autoplayTimeout= owlCarousel.data("autoplayTimeout"),
            speed 		= owlCarousel.data("speed"),
            column0 	= owlCarousel.data("column0"),
            column1 	= owlCarousel.data("column1"),
            column2 	= owlCarousel.data("column2"),
            column3 	= owlCarousel.data("column3"),
            column4 	= owlCarousel.data("column4"),
            column5 	= owlCarousel.data("column5"),
            margin		= owlCarousel.data("margin"),
            lazyLoad	= owlCarousel.data("lazyLoad"),    
            rtl         = window.routes.rtl;
        var config = {
          nav: 					nav,
          dots:					dots,
          margin:				margin,
          autoplay:				autoplay,
          autospeed: 			autospeed,
          autoplayTimeout: 		12000,
          speed:				speed,
          loop:					loop,
          autoWidth:			autowidth,    
          addClassActive:		true,
          lazyLoad:				lazyLoad,
          rtl:					 rtl,
          navText: ['<svg fill="currentcolor" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><polygon fill-rule="evenodd" points="9.414 12 16.707 19.293 15.293 20.707 6.586 12 15.293 3.293 16.707 4.707"/></svg>', '<svg fill="currentcolor" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><polygon fill-rule="evenodd" points="14.586 12 7.293 4.707 8.707 3.293 17.414 12 8.707 20.707 7.293 19.293"/></svg>'],
          navClass: ["owl-prev", "owl-next"],
          afterAction: 			FirstLastActiveItem,
          responsive:{
            0:{
              items:1,
            },
            321:{
              items:column4,
            },
            568:{
              items:column4,
            },
            768:{
              items:column3,
            },
            992:{
              items:column2,
              nav: nav,
            },
            1200:{
              items:column1,
              nav: nav,
            },
            1920:{
              items:column0,
              nav: nav,
            }
          }
        };
        if (autoplay){
          config.autospeed = autospeed;
        }
        owlCarousel.owlCarousel( config );
        function FirstLastActiveItem(el){
          el.find(".owl-item").removeClass("first");
          el.find(".owl-item.active").first().addClass("first");
          el.find(".owl-item").removeClass("last");
          el.find(".owl-item.active").last().addClass("last");
        }
      });
       
    },  
    
    initlOwlCarousel= function() {
      $(".ss-owl .owl-carousel").each(function(){
        var owlCarousel = $(this);
        var nav 		= owlCarousel.data("nav"),
            dots		= owlCarousel.data("dots"),
            autoplay 	= owlCarousel.data("autoplay"),
            loop 		= owlCarousel.data("loop"),
            autowidth 	= owlCarousel.data("autowidth"),
            autospeed 	= owlCarousel.data("autospeed"),
            autoplayTimeout= owlCarousel.data("autoplayTimeout"),
            speed 		= owlCarousel.data("speed"),
            column0 	= owlCarousel.data("column0"),
            column1 	= owlCarousel.data("column1"),
            column2 	= owlCarousel.data("column2"),
            column3 	= owlCarousel.data("column3"),
            column4 	= owlCarousel.data("column4"),
            column5 	= owlCarousel.data("column5"),
            margin		= owlCarousel.data("margin"),
            lazyLoad	= owlCarousel.data("lazyLoad"),
            rtl         = window.routes.rtl,
            animateout  = owlCarousel.data("animateout"),         
            animatein   = owlCarousel.data("animatein");

        var config = {
          nav: 					nav,
          dots:					dots,
          margin:				margin,
          autoplay:				autoplay,
          autospeed: 			autospeed,
          autoplayTimeout: 		12000,
          speed:				speed,
          loop:					loop,
          autoWidth:			autowidth,
          addClassActive:		true,
          lazyLoad:				lazyLoad,
          rtl:					 rtl,
          navText: ['<svg fill="currentcolor" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><polygon fill-rule="evenodd" points="9.414 12 16.707 19.293 15.293 20.707 6.586 12 15.293 3.293 16.707 4.707"/></svg>', '<svg fill="currentcolor" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><polygon fill-rule="evenodd" points="14.586 12 7.293 4.707 8.707 3.293 17.414 12 8.707 20.707 7.293 19.293"/></svg>'],
          navClass: ["owl-prev", "owl-next"],
          afterAction: 			FirstLastActiveItem,
          animateOut: animateout,
          animateIn: animatein,
          responsive:{
            0:{
              items:1,
            },
            321:{
              items:column5,
            },
            568:{
              items:column4,
            },
            768:{
              items:column3,
            },
            992:{
              items:column2,
              nav: nav,
            },
            1200:{
              items:column1,
              nav: nav,
            },
            1920:{
              items:column0,
              nav: nav,
            }
          }
        };
        if (autoplay){
          config.autospeed = autospeed;
        }
        owlCarousel.owlCarousel( config );
        function FirstLastActiveItem(el){
          el.find(".owl-item").removeClass("first");
          el.find(".owl-item.active").first().addClass("first");
          el.find(".owl-item").removeClass("last");
          el.find(".owl-item.active").last().addClass("last");
        }
      });
       
    },

    initlSlick= function() {
      $(".ss-slick .slider-slick").each(function(){
        var ss_slick = $(this);
        var nav 		= ss_slick.data("nav"),
            dots		= ss_slick.data("dots"),
            autoplay 	= ss_slick.data("autoplay"),
            loop 		= ss_slick.data("loop"),
            autowidth 	= ss_slick.data("autowidth"),
            autospeed 	= ss_slick.data("autospeed"),
            autoplayTimeout= ss_slick.data("autoplayTimeout"),
            speed 		= ss_slick.data("speed"),
            column0 	= ss_slick.data("column0"),
            column1 	= ss_slick.data("column1"),
            column2 	= ss_slick.data("column2"),
            column3 	= ss_slick.data("column3"),
            column4 	= ss_slick.data("column4"),
            column5 	= ss_slick.data("column5"),
            margin		= ss_slick.data("margin"),
            rtl         = window.routes.rtl,
            vertical   = ss_slick.data("vertical");
            var config = {
              arrows: 				nav,
              dots:					dots,
              margin:				margin,
              autoplay:				autoplay,
              autospeed: 			autospeed,
              autoplayTimeout: 		12000,
              vertical:             vertical,
              speed:				speed,
              loop:					loop,
              autoWidth:			autowidth,
              addClassActive:		true,
              slidesToShow: column0,
              responsive: [
                {
                  breakpoint: 0,
                  settings: {
                    slidesToShow: 1
                  }
                },                
                {
                  breakpoint: 321,
                  settings: {
                    slidesToShow: column5
                  }
                }, 
                {
                  breakpoint: 568,
                  settings: {
                    slidesToShow: column4
                  }
                },
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: column3
                  }
                },
                {
                  breakpoint: 992,
                  settings: {
                    slidesToShow: column2
                  }
                },
                {
                  breakpoint: 1200,
                  settings: {
                    slidesToShow: column1
                  }
                },
                {
                  breakpoint: 1920,
                  settings: {
                    slidesToShow: column0
                  }
                },
              ]
            };   
            ss_slick.slick( config );
      });  
    },
	
    initDropDownCart= function(cart, added) {
      $('#CartCount .cout_item').text(cart.item_count);
      $('.head-minicart .cout_item').text('('+cart.item_count+')');      
      $('.minicart-header #CartTotal .money').html(Shopify.formatMoney(cart.total_price, window.money_format));
      $('.minicart-header .price-total .price .money').html(Shopify.formatMoney(cart.total_price, window.money_format));      
      if( $('.template-cart').length > 0){
        return;
      }
      $('[data-cart-container]').empty();
  
      var items = [],
        item = {},
        data = {},
        source = $('#minicart-template').html();
        var template = Handlebars.compile(source);
        $.each(cart.items, function(index, cartItem) {
    		var prodImg; 
    		var unitPrice = null;
    		var disabled = '';
    		var variant_id = cartItem.variant_id;
    		var count = $('#count_quantity [data-variant_id="'+variant_id+'"]').data('count_quantity');
    		if( cartItem.quantity == count ){
    			disabled = 'disabled';
    		}
    		if (cartItem.image !== null) {
    			prodImg = cartItem.image
    				.replace(/(\.[^.]*)$/, '_compact$1')
    				.replace('http:', '');
    		} else {
    			prodImg = '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
    		}
    
    		if (cartItem.properties !== null) {
    			$.each(cartItem.properties, function(key, value) {
    				if (key.charAt(0) === '_' || !value) {
    					delete cartItem.properties[key];
    				}
    			});
    		}
    
    		if (cartItem.properties !== null) {
    			$.each(cartItem.properties, function(key, value) {
    				if (key.charAt(0) === '_' || !value) {
    					delete cartItem.properties[key];
    				}
    			});
    		}
    
    		if (cartItem.line_level_discount_allocations.length !== 0) {
    			for (var discount in cartItem.line_level_discount_allocations) {
    				var amount =
    				cartItem.line_level_discount_allocations[discount].amount;
    				cartItem.line_level_discount_allocations[
    						discount
    				].formattedAmount = smartaddons.Currency.formatMoney(
    					amount,window.money_format
    				);
    			}
    		}
    
    		if (cart.cart_level_discount_applications.length !== 0) {
    			for (var cartDiscount in cart.cart_level_discount_applications) {
    				var cartAmount =
    				cart.cart_level_discount_applications[cartDiscount]
    					.total_allocated_amount;
    
    				cart.cart_level_discount_applications[
    					cartDiscount
    				].formattedAmount = smartaddons.Currency.formatMoney(
    					cartAmount,
    					window.money_format
    				);
    			}
    		}
    
    		if (cartItem.unit_price_measurement) {
    			unitPrice = {
    				addRefererenceValue:
    				cartItem.unit_price_measurement.reference_value !== 1,
    				price: smartaddons.Currency.formatMoney(
    					cartItem.unit_price,
    					window.money_format
    				),
    				reference_value: cartItem.unit_price_measurement.reference_value,
    				reference_unit: cartItem.unit_price_measurement.reference_unit
    			};
    		}
    
          // Create item's data object and add to 'items' array
    		item = {
    			key: cartItem.key,
    			line: index + 1, // Shopify uses a 1+ index in the API
    			url: cartItem.url,
    			img: prodImg,
    			name: cartItem.product_title,
    			variation: cartItem.variant_title === null ? false : true,
    			variant: cartItem.variant,
    			options: cartItem.options_with_values,
    			variant_id: cartItem.variant_id,
    			properties: cartItem.properties,
    			itemAdd: cartItem.quantity + 1,
    			itemMinus: cartItem.quantity - 1,
    			itemQty: cartItem.quantity,
    			handle:cartItem.handle,
    			price: smartaddons.Currency.formatMoney(
    			  cartItem.original_line_price,
    			  window.money_format
    			),
    			discountedPrice: smartaddons.Currency.formatMoney(
    			  cartItem.final_line_price,
    			  window.money_format
    			),
    			discounts: cartItem.line_level_discount_allocations,
    			discountsApplied:cartItem.line_level_discount_allocations.length === 0 ? false : true,
    			vendor: cartItem.vendor,
    			unitPrice: unitPrice,
    			disabled:disabled
    		};
    		items.push(item);
        });
        
        // Gather all cart data and add to DOM
        data = {
    		items: items,
    		note: cart.note,
    		totalPrice: smartaddons.Currency.formatMoney(
    			cart.total_price,
    			window.money_format
    		),
    		cartDiscounts: cart.cart_level_discount_applications,
    		cartDiscountsApplied:cart.cart_level_discount_applications.length === 0 ? false : true
        };   
        $('[data-cart-container]').append(template(data));
    	$('.pre_order-cart >span').each(function(){
    		var id = $(this).data('handle');
    		for (var i in data.items) {
    			if(data.items[i].variant_id == id) {
    				$('.minicart__product[data-line="'+data.items[i].line+'"] .pre_order').removeClass('hidden');
    			}
    		}
    	});

        buildCart();
        if( $(".drawer").length > 0 ){
          drawerFooter();
        }
        checkbox_terms_conditions_agree();
        
        if ($('.mini-products-list li').length > 0) {
          $('.minicart-header .block-content .no-items').hide();
          $('.minicart-header .block-content .has-items').show();
        }
        else {
          $('.minicart-header .block-content .has-items').hide();
          $('.minicart-header .block-content .no-items').show();
        }
    },

    drawerFooter = function() {
      var $cartFooter = $('.minicart__footer').removeAttr('style');
      var $cartInner = $('.minicart__inner').removeAttr('style');
      var cartFooterHeight = $cartFooter.outerHeight();
      $cartInner.css('bottom', cartFooterHeight);
      $cartFooter.css('height', cartFooterHeight);

      	$(".minicart__info .button_note").on( "click", function() {
      		if($('.minicart__info .minicart__note').hasClass('active')){
      			$('.minicart__info .minicart__note').removeClass('active');	
      		}else{
      			$('.minicart__info .minicart__note').addClass('active');		
      		}
      	});
      	$(".minicart__info .button_discount").on( "click", function() {
      		if($('.minicart__info .discount_code').hasClass('active')){
      			$('.minicart__info .discount_code').removeClass('active');	
      		}else{
      			$('.minicart__info .discount_code').addClass('active');		
      		}
      	});
      	$(".minicart__info .button_shiping").on( "click", function() {
      		if($('#minicart-sidebar #shipping-calculator').hasClass('active')){
      			$('#minicart-sidebar #shipping-calculator').removeClass('active');	
      		}else{
      			$('#minicart-sidebar #shipping-calculator').addClass('active');		
      		}
      	});
      	$(".minicart__info .close-minicart__info").on( "click", function() {
      		if($('.minicart__info .minicart__info_content >div').hasClass('active')){
      			$('.minicart__info .minicart__info_content >div').removeClass('active');
      		}
      	});
      	$(".minicart__info .save").on( "click", function() {
      		if($('.minicart__info .minicart__info_content >div').hasClass('active')){
      			$('.minicart__info .minicart__info_content >div').removeClass('active');
      		}
      	});
      	$("#minicart-sidebar #shipping-calculator .close-minicart__info").on( "click", function() {
      		if($('#minicart-sidebar #shipping-calculator').hasClass('active')){	
      			$('#minicart-sidebar #shipping-calculator').removeClass('active');
      		}
      	});
      
    	Shopify.Cart.ShippingCalculator.show( {
    	  submitButton: window.strings.shippingCalcSubmitButton,
    	  submitButtonDisabled: window.strings.shippingCalcSubmitButtonDisabled,
    	  customerIsLoggedIn: window.strings.shippingCalcCustomerIsLoggedIn,
    	  moneyFormat: window.money_format,
    	  CalculateMessSuccess: window.strings.CalculateMessSuccess,
    	  CalculateMessPrice: window.strings.CalculateMessPrice,
    	  CalculateMessError: window.strings.CalculateMessError
    	});
    };

      
    product_count_sales = function() {
		if( $(".product_count-sales").length > 0 ){
			var id_product = $(".product_count-sales").data("id_product");
			var min = $(".product_count-sales").data("min") ? $(".product_count-sales").data("min") : 20;
			var max = $(".product_count-sales").data("max") ? $(".product_count-sales").data("max") : 30;
			var time_min = $(".product_count-sales").data("time_min") ? $(".product_count-sales").data("time_min") : 20;
			var time_max = $(".product_count-sales").data("time_max") ? $(".product_count-sales").data("time_max") : 30;
			var cookieValue = smartaddonSS.getCookie("product_"+id_product);
			var cookieTime = smartaddonSS.getCookie("time_"+id_product);
			if( cookieValue && cookieTime) {
				$("span.count",".product_count-sales").html(cookieValue);
				$("span.time",".product_count-sales").html(cookieTime);
			}else{
				var rand = Math.round(Math.random() * (max - min)) + min;
				var time = Math.round(Math.random() * (time_max - time_min)) + time_min;
				smartaddonSS.setCookie("product_"+id_product, rand, { expires : 24 * 60 * 60 * 1000 });
				smartaddonSS.setCookie("time_"+id_product, time, { expires : 24 * 60 * 60 * 1000 });
				$("span.count",".product_count-sales").html(rand);	
				$("span.time",".product_count-sales").html(time);
			}
		}
	},  
    // product real time
    product_real_time =function() {
		if( $(".product_real-time").length > 0 ){
			var id_product = $(".product_real-time").data("id_product");
			var min = $(".product_real-time").data("min") ? $(".product_real-time").data("min") : 20;
			var max = $(".product_real-time").data("max") ? $(".product_real-time").data("max") : 30;
			var timeout = $(".product_real-time").data("timeout") ? $(".product_real-time").data("timeout") : 10000;
			var auto = Math.round(Math.random() * (max - min)) + min;
			$("span",".product_real-time").html(auto);
			setTimeout(function random() {
				var auto = Math.round(Math.random() * (max - min)) + min;
				$("span",".product_real-time").html(auto);
				setTimeout(random, timeout);
			}, timeout);
		}
	},  
    color_compare= function() {
        if( $(".product-single .color-compare").length > 0 ){
            var $element = $( ".product-single .color-compare" );
          	$(".color_compare_label",$element).on( "click", function() {
          		if(!$('.color-compare-content').hasClass('active')){
          			$('.color-compare-content').addClass('active');		
                    $( ".product__info-media" ).css("position","relative");
                    $( ".product__info-container" ).css("position","relative"); 
                    $("body").addClass('overflow_hidden');
					setTimeout(function(){
						$(".popup_color_compare",$element).addClass('active');
					}, 300);                  
          		}
          	});
			$(".product-single .color_compare_close").on( "click", function() {
				if($(".color-compare-content",$element).hasClass('active')){
					$(".popup_color_compare",$element).removeClass('active');
					setTimeout(function(){
						$(".color-compare-content",$element).removeClass('active');
					}, 300);
                    $("body").removeClass('overflow_hidden');
				}
			});          
              $(".color-compare .item-color svg").on( "click", function() {
                  if($(this).is(":hidden")) {
                  } else {
                     if($('.'+$(this).parent().data('color')).hasClass("hidden")) {
                       $('.'+$(this).parent().data('color')).removeClass('hidden');
                     } else {
                       $('.'+$(this).parent().data('color')).addClass('hidden');
                     }
                     $(this).parent().find('svg:hidden').removeAttr("hidden");
                     $(this).attr("hidden","hidden");
                  }
              }); 
        }
    },       
     //Ask a question
    ask_a_question= function() {
		if( $(".product-single .product_question").length > 0 ){
			$(".product_question .open_question").on( "click", function(event) {
				if($('.product_question .question_form').hasClass('active')){
					$('.product_question .question_form').removeClass('active');	
					$(".product_question .question_form .content-form").removeClass('active');
                    $("body").removeClass('overflow_hidden');
				}else{
					$('.product_question .question_form').addClass('active');
                    $( ".product__info-media" ).css("position","relative");
                    $( ".product__info-container" ).css("position","relative");      
                    $("body").addClass('overflow_hidden');
					setTimeout(function(){
						$(".product_question .question_form .content-form").addClass('active');
					}, 300);
				}               
			});
			$(".product_question .close_question_form").on( "click", function() {
				if($('.product_question .question_form').hasClass('active')){
					$(".product_question .question_form .content-form").removeClass('active');
					setTimeout(function(){
						$('.product_question .question_form').removeClass('active');
					}, 300);
                    $("body").removeClass('overflow_hidden');
				}         
			});
			setTimeout(function() { 
				$('.product_question .alert').remove();
			}, 2000);
		}
	},
     //End Ask a question
     //Share
    single_product_share= function() {
		if( $(".product-single .product_share").length > 0 ){
			var $element = $( ".product-single .product_share" );
			$(".product_share_label",$element).on( "click", function() {
				if(!$(".product_share_content",$element).hasClass('active')){
					$(".product_share_content",$element).addClass('active');
					setTimeout(function(){
						$(".popup_product_share",$element).addClass('active');
					}, 300);
                    $( ".product__info-media" ).css("position","relative");
                    $( ".product__info-container" ).css("position","relative"); 
                    $("body").addClass('overflow_hidden');
				}
			});
			$(".product-single .share_close").on( "click", function() {
				if($(".product_share_content",$element).hasClass('active')){
					$(".popup_product_share",$element).removeClass('active');
					setTimeout(function(){
						$(".product_share_content",$element).removeClass('active');
					}, 300);
                    $("body").removeClass('overflow_hidden');
				}
			});
			 $(".share_copy button", $element).click(function () {
				var copyText =  $(".share_copy .url_share", $element).attr('value');
				var $text =  $(".share_copy", $element).data('text');
				var $temp = $("<input>");
				$("body").append($temp);
				$temp.val(copyText).select();
				document.execCommand("copy");
				$temp.remove();
				var notificationTag = $("div.copy-notification");
				if ( notificationTag.length == 0) {
					notificationTag = $("<div/>", { "class": "copy-notification", text: $text });
					$("body").append(notificationTag);
					notificationTag.fadeIn("slow", function () {
						setTimeout(function () {
							notificationTag.fadeOut("slow", function () {
								notificationTag.remove();
							});
						}, 1000);
					});
				}
			});
		}
	},
    //End Share
    checkbox_terms_conditions_agree = function() {
    	if ( $(".ss_terms_conditions").length > 0 ) {
    		if ($(".ss_terms_conditions_agree").is(":checked")) {
    		   $('[name="checkout"], [name="goto_pp"], [name="goto_gc"]').prop('disabled', false);
    		} else {
    			$('[name="checkout"], [name="goto_pp"], [name="goto_gc"]').prop('disabled', true);
    		}
    		setTimeout(function() {
    			if ($(".ss_terms_conditions_agree").is(":checked")) {
    			   $('[data-shopify="payment-button"] button').prop('disabled', false);
    			} else {
    				$('[data-shopify="payment-button"] button').prop('disabled', true);
    			}
    		},1000);
    		$("body").on(
    			"click",
    			'.ss_terms_conditions_agree',
    			function () {
    				if ($(this).is(":checked")) {
    					$('body').find('.ss_terms_conditions_agree').each(function() {
    						$(this).attr("checked", "checked");
    					});
    				   $('[data-shopify="payment-button"] button, [name="checkout"], [name="goto_pp"], [name="goto_gc"]').prop('disabled', false);
    				} else {
    					$('body').find('.ss_terms_conditions_agree').each(function() {
    						$(this).removeAttr('checked');
    					});
    					$('[data-shopify="payment-button"] button, [name="checkout"], [name="goto_pp"], [name="goto_gc"]').prop('disabled', true);
    				}
    			}
    		);
    		$('.ss_content_terms_conditions [data-close-terms_conditions]').on('click', function(e) {
    			$('.ss_content_terms_conditions').removeClass('show');
    			setTimeout(function() {
    				$('.ss_content_terms_conditions').removeClass('active');
    			},300);
    		});
    		$('.ss_terms_conditions a').on('click', function(e) {
    			e.preventDefault();
    			$('.ss_content_terms_conditions').addClass('active');
    			setTimeout(function() {
    				$('.ss_content_terms_conditions').addClass('show');
    			},300);
    		}); 
        }
    };
      
    //ss_terms_conditions_agree
      
     estimated_delivery_time = function() {
      	if( $(".product-single .estimated_delivery").length > 0 ){
      		var code_time =  window.routes.iso_code;
      		var $element			= $( ".product-single .estimated_delivery" );
      		var datenow_preorder 	= $( ".product-single .estimated_delivery" ).data('date_now')
      		if(datenow_preorder){
      			var datenow 		= new Date(datenow_preorder).getTime();
      		}else{
      			var datenow 		= Date.now();
      		}
      		var date 				= new Date,
      			day 				= 24*60*60*1000,
      			day_ship 			= $($element ).data('number_day');
      		var day_to 			= new Date(day_ship*day + datenow);
      		var day_from 			= new Date((day_ship + 3)*day + datenow);
      		var day_to 			= day_to.toLocaleDateString(code_time, { month:"short", day:"numeric"});
      		var day_from 			= day_from.toLocaleDateString(code_time, { month:"short", day:"numeric"});
      		$("span.day_to",$element).html(day_to);
      		$("span.day_from",$element).html(day_from);
      	}
  },
    estimated_delivery= function(variant) {
		if( $(".product-single .estimated_delivery").length > 0 && $(".product-single .product_estimated_delivery[data-incoming]").length > 0 ){
			$('.product-single .product_estimated_delivery').addClass('load-delivery').css("height", $('.product-single .product_estimated_delivery').height() + 'px');
			setTimeout(function(){
				$( ".product-single .product_estimated_delivery" ).load(window.location.href + ".product-single .estimated_delivery" );				
			}, 10);
			setTimeout(function(){
				if( $(".product-single .time_hour").length > 0 ){
					this.estimated_delivery_time();
				}
			}, 1200);
			setTimeout(function(){
				if( $(".product-single .time_hour").length > 0 ){
					$('.product-single .product_estimated_delivery').removeClass('load-delivery').removeAttr('style');
				}
			}, 1400);
		}
    },
    initQuickView= function() {
      $(document).on('click', '.quickview-button a', function() {       
        var product_handle = $(this).data('id');
        var variants_id = $(this).data('variants_id');      
        $('[data-variants_id="'+variants_id+'"]').addClass('load-quickview');
        setTimeout(function() { 
            $('[data-variants_id="'+variants_id+'"]').removeClass('load-quickview');
        }, 2000);         
        Shopify.getProduct(product_handle, function(product) {
          var template = $('#quickview-template').html();
          $('.quick-view').html(template);
          var quickview = $('.quick-view');

          quickview.find('.product-title a').html(product.title);
          quickview.find('.product-title a').attr('href', product.url);
          
          if (quickview.find('.product-vendor span').length > 0) {
            quickview.find('.product-vendor span').html('<a href="/collections/vendors?q='+product.vendor+'" title="'+product.vendor+'">'+product.vendor+'</a>');
          }
          var product_review = $('#product-item-card-'+product.id+' .product-reviews').html();
          quickview.find('.product-review').append(product_review);
          quickview.find('.box-labels').html('');
          var box_labels = $('#product-item-card-'+product.id+' .box-labels').html();
          quickview.find('.box-labels').append(box_labels);

          if (quickview.find('.product-type span').length > 0 && product.type != "" && product.type != null) {
            quickview.find('.product-type').show();
            quickview.find('.product-type span').text(product.type);
          } else {
            quickview.find('.product-type').hide();
          }

          if (quickview.find('.product-inventory span').length > 0) {
              var variant = product.variants[0];
              var inventoryInfo = quickview.find('.product-inventory span');  
              if (variant.available) {
                if (variant.inventory_management!=null) {
                  inventoryInfo.html('<i class="fa fa-check-square-o"></i>' + window.trans_text.in_stock);
                } else {
                  inventoryInfo.text(window.trans_text.many_in_stock);
                }
              } else {
                inventoryInfo.text(window.trans_text.out_of_stock);
              }
  
              if (quickview.find('.product-sku span').length > 0 && variant.sku != "" && variant.sku != null) {
                quickview.find('.product-sku').show();
                quickview.find('.product-sku span').text(variant.sku);
              } else {
                quickview.find('.product-sku').hide();
              }
              quickview.find('.price').html(Shopify.formatMoney(variant.price, window.money_format));
              
              if (variant.compare_at_price != null && variant.compare_at_price > variant.price) {
                quickview.find('.compare-price').html(Shopify.formatMoney(variant.compare_at_price, window.money_format)).show();
                quickview.find('.price').addClass('on-sale');
              } else {
                quickview.find('.compare-price').html('');
                quickview.find('.price').removeClass('on-sale');
              }            
          }

          if (quickview.find('.product-description').length > 0) {
            var description = product.description.replace(/(<([^>]+)>)/ig, "");
            var description = description.replace(/\[countdown\](.*)\[\/countdown\]/g, "");
            description     = description.split(" ").splice(0, 30).join(" ") + "...";
            quickview.find('.product-description').text(description);
          } else {
            quickview.find('.product-description').remove();
          }

         
          quickview.find('.product-item').attr('id', 'product-' + product.id);
          quickview.find('.variants').attr('id', 'product-actions-' + product.id);
          quickview.find('.variants select').attr('id', 'product-select-' + product.id);

          quickview.find(".button").on("click", function() {
            var oldValue = quickview.find(".quantity").val(),
                newVal = 1;
            if ($(this).text() == "+") {
              newVal = parseInt(oldValue) + 1;
            } else if (oldValue > 1) {
              newVal = parseInt(oldValue) - 1;
            }
            quickview.find(".quantity").val(newVal);

            if (quickview.find(".total-price").length > 0) {
              updatePricingQuickview();
            }
          });

          if (!product.available) {
            quickview.find("select, input, .total-price, .dec, .inc, .variants label").remove();
            quickview.find(".add-to-cart-btn").text(window.trans_text.unavailable).addClass('disabled').attr("disabled", "disabled");
          } else {
            quickview.find('.total-price span').html(Shopify.formatMoney(product.price, window.money_format));
            quickview.find('.product-quickview__variants').html(createQuickViewVariants(product, quickview));
          }
          initQuickViewAddToCart(product);
          $('.quick-view').css('display','block');
          loadQuickViewImage(product, quickview);
          checkbox_terms_conditions_agree();

          if ($('.quick-view .total-price').length > 0) {
            $('.quick-view input[name=quantity]').on('change', updatePricingQuickview);
          }

          if( $('.currency-Picker').length > 0){
            Currency.convertAll(window.shop_currency, jQuery('select[name=currencies] option:selected').val(), '.quick-view span.money', 'money_format');
          }
        });

        return false
      });

      $(document).on("click", ".quick-view .overlay, .close-quickview", function() {
        closeQuickViewPopup();
        return false;
      });
    },

    showLoading= function() {
      $('.ss-loading').show();
    },

    hideLoading= function() {
      $('.ss-loading').hide();
    },

    showPopup= function (selector) {
      $(selector).addClass('active');
    },

    closeQuickViewPopup= function() {
      $('.quick-view').css('display','none');
    },

    hidePopup= function (selector) {
      $(selector).removeClass('active');
    },

    hidePu= function() {
      $('.close-pu').click(function() {
        $('.modal-pu').removeClass('active');
        return false;              
      }); 
    },

    initProductAddToCart= function() {
      if ($('#AddToCart-product-template').length > 0) {
        $('#AddToCart-product-template').click(function(event) {
          event.preventDefault();
          if ($(this).attr('disabled') != 'disabled') {

            var variant_id = $('form.product-form select[name=id]').val();
            if (!variant_id) {
              variant_id = $('form.product-form input[name=id]').val();
            }
            var quantity = $('form.product-form input[name=quantity]').val();
            if (!quantity) {
              quantity = 1;
            }
            var title = $('h1.product-single__title').html();
            var image = $('.product-featured-img').attr('src');
            doAjaxAddToCart(variant_id, quantity, title, image);
          }
          return false;
        });
      }
    },
    initAddToCart= function () {
      $(document).on('click', '.product-item .btn-addToCart', function(event) {    
        event.preventDefault();
        if ($(this).attr('disabled') != 'disabled') {      
          var productItem = $(this).closest('.product-item');
          var productId = $(this).closest('.product-item').data('id');      
          var variant_id = $(this).parent('.btn-button').find('select[name=id]').val();
          if (!variant_id) {
            variant_id = $(this).parent('.btn-button').find('input[name=id]').val();
          }
          if (!variant_id) {
            variant_id = $(this).parent('form').find('input[name=id]').val();
          }          
          var quantity = $(this).parent('.btn-button').find('input[name=quantity]').val();
          if (!quantity) {
            quantity = 1;
          }
          var title = $(productItem).find('.product-name').html();
          var image = $(productItem).find('.image-ajax img').attr('src');
          doAjaxAddToCart(variant_id, quantity, title, image , productId); 
          closeQuickViewPopup();
        }
        return false;
      });
    },
	getCurrentOptions= function() {
			var currentOptions = _.map(
				$('.js-quickview-option-selector', '.quick-view .content'), function(element) {
					var $element = $(element);
					var type = $element.attr('type');
					var currentOption = {};
					if (type === 'radio' || type === 'checkbox') {
						if ($element[0].checked) {
							currentOption.value = $element.val();
							currentOption.index = $element.data('index');
							return currentOption;
						} else {
							return false;
						}
					} else {
						currentOption.value = $element.val();
						currentOption.index = $element.data('index');
						return currentOption;
					}
				}
			);
			currentOptions = _.compact(currentOptions);
            
			return currentOptions;
	},       
    getVariantFromOptions= function(product) {
		var selectedValues = getCurrentOptions();
        var variants = product.variants;
		var found = _.find(variants, function(variant) {
			return selectedValues.every(function(values) {
				return _.isEqual(variant[values.index], values.value);
			});
		});
		return found;
    },       

    initQuickViewAddToCart= function (product) {
	  $('.quick-view .content').on('change', '.js-quickview-option-selector', function(e) {  
			var variant = getVariantFromOptions(product);
            $('.ss-add-cart-quickview option[value=' + variant.id + ']').attr('selected',true);
            $('.quick-view .content').find('.price').html(Shopify.formatMoney(variant.price, window.money_format));
            if (variant.compare_at_price != null && variant.compare_at_price > variant.price) {
               $('.quick-view .content').find('.compare-price').html(Shopify.formatMoney(variant.compare_at_price, window.money_format));
            }
            if ($('.quick-view .content').find('.product-sku span').length > 0 && variant.sku != "" && variant.sku != null) {
                $('.quick-view .content').find('.product-sku').show();
                $('.quick-view .content').find('.product-sku span').text(variant.sku);
              } else {
                $('.quick-view .content').find('.product-sku').hide();
            }        
            $('.add-to-cart-btn span').html(window.variantStrings.addToCart);
        	$('.pre_order-cart >span').each(function(){
        		var id = $(this).data('handle');
        		if(variant.id == id) {
        			$('.add-to-cart-btn span').html(window.variantStrings.preOrder);
        		}
        	});
            if(variant.featured_media !== undefined) {
                var indexOwl = $('.quick-view .product-photo-thumbs a[data-image-id=' + variant.featured_media.id + ']').parent().parent().index();
                $('.quick-view .product-photo-thumbs').trigger('to.owl.carousel', indexOwl);             
            }
            if( $('.currency-Picker').length > 0){
              Currency.convertAll(window.shop_currency, jQuery('select[name=currencies] option:selected').val(), 'span.money', 'money_format');
            }        
	  });      
      
      $('.quick-view .add-to-cart-btn').click(function(event) {
        event.preventDefault();
        if ($(this).attr('disabled') != 'disabled') {      
          var variant_id = $('.quick-view select[name=id]').val();
          if (!variant_id) {
            variant_id = $('.quick-view input[name=id]').val();
          }

          var title = $('.quick-view .product-title a').html();
          var image = $('.quick-view .product-photo-thumbs a img').attr('src');

          var quantity = $('.quick-view input[name=quantity]').val();
          if (!quantity) {
            quantity = 1;
          }

          doAjaxAddToCart(variant_id, quantity, title, image); 
          closeQuickViewPopup();
        }

        return false;
      });
    },

    buys_together_home  = function() {
			var $thisWrap = $('.products-item-wrap');
			var $thisSSWrap = $thisWrap.closest('.ss-buytogether-products');
			var $thisProductsSSWrap = $thisSSWrap.find('.products-item-wrap');
			var total_items = 0;
			var total_price = 0; 
			$thisWrap.find('.product-item').each(function (index, element) {
				var this_price = $(element).find('.ss-buytogether-price').attr('data-price');
				if (!isNaN(this_price)) {
					total_price = Number(total_price) + Number(this_price);
				}
			});
			$thisSSWrap.find('span.total-price').html('<span class="money">'+ smartaddons.Currency.formatMoney(total_price,window.money_format) + '</span>');
            if( $('.currency-Picker').length > 0){
                Currency.convertAll(window.shop_currency, jQuery('select[name=currencies] option:selected').val(), 'span.money', 'money_format');
            }     

    		$('.ss_buyss_together_home_form .buy-together-add-all-to-cart').on('click',function(e){
    			e.preventDefault();
    			$(this).addClass('active');
    			let addToCartForm = document.querySelector('.ss_buyss_together_home_form');
    			let formData = new FormData(addToCartForm);
                console.log(formData);
    			var params = {
    				type: 'POST',
    				url: '/cart/add.js',
    				data: formData,
    				processData: false,
    				contentType: false,
    				dataType: 'json',
    				success: function(line_item) {
    					$('.buy-together-add-all-to-cart').removeClass('active');
    					document.location.href = '/cart';
    				},
    				error: function(XMLHttpRequest, textStatus) {
    					if (typeof errorCallback === 'function') {
    						errorCallback(XMLHttpRequest, textStatus);
    					} else {
    						ShopifyAPI.onError(XMLHttpRequest, textStatus);
    					}
    				}
    			};
    			jQuery.ajax(params);
    		});      
    },
    buildCart= function() {
        if($('.shipping-bar-cart').length) {
            var price_shipping_bar 	= $('.shipping-bar-cart').data("price_shipping_bar");
            $.getJSON('/cart.js', function(cart) {
                 
                $.each(cart.items, function(index, cartItem) {
                    $('.cart-product-edit_variant[data-id_variant='+cartItem.id+']').attr("data-handle",cartItem.handle);
                    $('.cart-product-edit_variant[data-id_variant='+cartItem.id+']').attr("data-line",index + 1);
                });
                $('.cart-total__subtotal-price').html(Shopify.formatMoney(cart.total_price, window.money_format));              
      			if(price_shipping_bar > cart.total_price && price_shipping_bar != 0){
      				var minus_spend 		= price_shipping_bar - cart.total_price;
      				var spend 				= Shopify.formatMoney(minus_spend, window.money_format);
      				var percent				= cart.total_price/price_shipping_bar*100;
      				$('.shipping-bar-cart .title-spend .spend').html(spend);
      				$('.shipping-bar-cart .shipping-progress').css("width",percent+"%");
      				$('.shipping-bar-cart .title-shipping').addClass('hide');
      				$('.shipping-bar-cart .title-spend').removeClass('hide');
      				$('.shipping-bar-cart').removeClass('full');
      				$('.shipping-bar-cart .shipping-progress').removeClass('fire-done');
      				$('#fire_work').addClass('hide');
      			}else {
      				$('.shipping-bar-cart .title-shipping').removeClass('hide');
      				$('.shipping-bar-cart .title-spend').addClass('hide');
      				$('.shipping-bar-cart .shipping-progress').css("width","100%");
      				$('.shipping-bar-cart').addClass('full');
      				if(!$('.shipping-bar-cart .shipping-progress').hasClass('fire-done')){
      					$('.shipping-bar-cart .shipping-progress').addClass('fire');
      				}
      				if($('.shipping-bar-cart .shipping-progress').hasClass('fire')){
      					$('#fire_work').removeClass('hide');
      				}
      				setTimeout(function() {
      					$('.shipping-bar-cart .shipping-progress').addClass('fire-done');
      					$('.shipping-bar-cart .shipping-progress').removeClass('fire');
      				},100);
      				setTimeout(function() {
      					$('#fire_work').addClass('hide');
      				},5000);
      			}
                if( $('.currency-Picker').length > 0){
                    Currency.convertAll(window.shop_currency, jQuery('select[name=currencies] option:selected').val(), 'span.money', 'money_format');
                }               
             });	        
          } else {
            $.getJSON('/cart.js', function(cart) {
                $.each(cart.items, function(index, cartItem) {
                    $('.cart-product-edit_variant[data-id_variant='+cartItem.id+']').attr("data-handle",cartItem.handle);
                    $('.cart-product-edit_variant[data-id_variant='+cartItem.id+']').attr("data-line",index + 1);
                });
            });	            
          }
          if($('.template-cart').length) {
        	  $('.template-cart .pre_order-cart >span').each(function(){
        			var id = $(this).data('handle');
                    $('.template-cart .cart-item').each(function(){  
                        var idc = $(this).data('id_variant');
        				if(idc == id) {
        					$('.template-cart .cart-item[data-id_variant="'+idc+'"] .pre_order').removeClass('hidden');
        				}
        			});
        	  });      
          };  
    }       
	
    btnAddtocart= function() {
    
      $(window.btn_addToCart).click(function(event) { 
        event.preventDefault();
        if ($(this).attr('disabled') != 'disabled') {
          var variant_id = $(window.product_detail_form +' select[name=id]').val();
          if (!variant_id) {
            variant_id = $(window.product_detail_form +' input[name=id]').val();
          }
          var quantity = $(window.product_detail_form +' input[name=quantity]').val();
          if (!quantity) {
            quantity = 1;
          }
          var title = $(window.product_detail_name).html();
          var image = $(window.product_detail_mainImg).attr('src');
          doAjaxAddToCart(variant_id, quantity, title, image);
        }

        return false;
      });
    },

	updateModalRecommendations = function(lineItem) {
		var baseUrl = routes.product_recommendations_url;
		var productId = lineItem.product_id;
		var recommendationsSectionUrl = baseUrl + '?section_id=product-recommendations&product_id=' + productId +'&limit=4';
		$.get(recommendationsSectionUrl).then(function(section) {
			var recommendationsMarkup = $(section).html();
			$(".cart-recommendations").html(recommendationsMarkup);		
            initlOwlCarousel();
            smartaddonSS.click_atribute_image();
            initCountd();
		});
	};
    
    doAjaxAddToCart= function(variant_id, quantity, title, image , productId) {
      $.ajax({
        type: "post",
        url: "/cart/add.js",
        data: 'quantity=' + quantity + '&id=' + variant_id, 
        dataType: 'json', 
        beforeSend: function() {    
          $('[data-id='+productId+'] .add-to-cart').addClass('load-add-to-cart');
        },
        success: function(response) {     
          $('[data-id='+productId+'] .add-to-cart').removeClass('load-add-to-cart');
          hidePopup('.quickview-product');       
          switch (window.addcart_susscess) {
            case ('popup'):
              var optionvalue = '';
              $('.pu-cart').find('.option').html('');  
              for (i in response.options_with_values) {
                 if(response.options_with_values[i].value != "Default Title") {
                   optionvalue +='<small>'+response.options_with_values[i].name+': '+response.options_with_values[i].value+'</small>';    
                 }  
              }
              $('.pu-cart').find('.option').append(optionvalue);    
              $('.pu-cart').find('.variant-id').html('<input type="hidden" data-modal-variant name="id" value="'+variant_id+'">');
              $('.pu-cart').find('.product-name').html(title);    
              $('.pu-cart').find('.product-image img').attr('src', image);
              $('.pu-cart').find('.product-type .product-type--value').html(response.product_type);
              $('.pu-cart').find('.cart-price-total .price-total').html(response.quantity);
              $('.pu-cart').find('.quantity__input').val(response.quantity);          
              $('.pu-cart').find('.cart-price-total .price-new').html(Shopify.formatMoney(response.price, window.money_format));
              $('.pu-cart').find('.previewCartCheckout-price').html(Shopify.formatMoney(response.price*response.quantity, window.money_format));
              updateModalRecommendations(response);
              if( $('.currency-Picker').length > 0){
                 Currency.convertAll(window.shop_currency, jQuery('select[name=currencies] option:selected').val(), 'span.money', 'money_format');
              }              
              showPopup('.pu-cart');
              
              break;
            case ('text'):
              hidePopup('.loading'); 
              hideLoading('.btn-addToCart');
              break;
            case ('noitice'):          
              hidePopup('.loading'); 
              hideLoading('.btn-addToCart');
              $('.product-noitice.susscess').find('.product-name').html(title);
              $('.product-noitice.susscess').find('.product-image img').attr('src', image);
              showNoitice('.product-noitice.susscess');
              break;
            default:
              showPopup('.pu-cart');
              break;
          }
          updateMiniCart();
          updateToolsCart();
          buildCart();
          return false;
        },
        error: function(xhr, text) {
          console.log(text);
          console.log(xhr);
          $('.ss-loading').hide();
          $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
          showPopup('.error-popup');
        }
      });
    },

    updateMiniCart= function() {
        ShopifyAPI.getCart(initDropDownCart);      
    },

    updateToolsCart= function() {
      Shopify.getCart(function(cart) {
        doUpdateToolsCart(cart);
      });
    },

    doUpdateToolsCart= function(cart) {
      var template = '';
      template += '<tr>';
      template += '<td class="text-left first"><a href="{URL}"><img class="img-thumbnail img-responsive" src="{IMAGE}" alt="{TITLE}" /></a></td>';
      template += '<td class="text-left"><a href="{URL}">{TITLE}</a></td>';
      template += '<td class="text-right">x&nbsp;{QUANTITY}</td>';
      template += '<td class="text-right total-price">{PRICE}</td>';
      template += '<td class="text-right last"><a href="javascript:;" data-productid="{ID}" return false;" class="btn-remove"><i class="fa fa-trash"></i></a></td>';
      template += '</tr>';

      $('#scartcount').text(cart.item_count);
      $('.popup-mycart .cart-header .cart-bottom span.money').html(Shopify.formatMoney(cart.total_price, window.money_format));
      $('.popup-mycart .cart-header .cart-bottom span.money').attr('data-currency-usd', Shopify.formatMoney(cart.total_price, window.money_format));
      $('.popup-mycart .cart-header table.list-cart tbody').html('');

      if (cart.item_count > 0) {
        for (var i = 0; i < cart.items.length; i++) {
          var item = template;
          item = item.replace(/\{ID\}/g, cart.items[i].id);
          item = item.replace(/\{URL\}/g, cart.items[i].url);
          item = item.replace(/\{TITLE\}/g, cart.items[i].title);
          item = item.replace(/\{QUANTITY\}/g, cart.items[i].quantity);
          item = item.replace(/\{IMAGE\}/g, Shopify.resizeImage(cart.items[i].image, '80x80'));
          item = item.replace(/\{PRICE\}/g, Shopify.formatMoney(cart.items[i].price, window.money_format));
          $('.popup-mycart .cart-header table.list-cart tbody').append(item);
        }

        $(document).on('click', '.so-groups-sticky .popup-mycart .btn-remove', function(event) {
          event.preventDefault();
          var productId = $(this).data('productid');
          Shopify.removeItem(productId, function(cart) {
            doUpdateToolsCart(cart);
          });
        });

        if( $('.currency-Picker').length > 0){
          Currency.convertAll(window.shop_currency, jQuery('select[name=currencies] option:selected').val(), '.so-groups-sticky span.money', 'money_format');
        }
      }
    },

    loadQuickViewImage= function(product, quickviewTemplate) {
      var featuredImage = Shopify.resizeImage(product.featured_image, 'grande');
      if (product.media.length > 0) {
        var quickViewCarousel = quickviewTemplate.find('.more-view-wrapper ul');
        var count = 0;
        for (i in product.media) {
          if (count < product.media.length) {
            var grande = Shopify.resizeImage(product.media[i].src, 'grande');
            var compact = Shopify.resizeImage(product.media[i].src, 'compact');
            if(product.media[i].media_type == "video") {
              var item = '<li><a '+(count == 0 ? 'class="actived"' : '')+' href="javascript:void(0)" data-image-id="' + product.media[i].id + '" ><video width="100%" playsinline="playsinline" controls="controls" class="media-video" preload="metadata"><source src="'+product.media[i].sources[0].url+'" type="video/mp4"></video></a></li>'
            } else {
              var item = '<li><a '+(count == 0 ? 'class="actived"' : '')+' href="javascript:void(0)" data-image-id="' + product.media[i].id + '" ><img src="' + grande + '"  /></a></li>'
            }
            quickViewCarousel.append(item);
            count = count + 1;
          }
        }

        quickViewCarousel.find('a').click(function() {
          var quickViewFeatureImage = quickviewTemplate.find('.quickview-image img');
          var quickViewFeatureLoading = quickviewTemplate.find('.quickview-image div');
          if (quickViewFeatureImage.attr('src') != $(this).attr('data-image')) {
            quickViewFeatureImage.attr('src', $(this).attr('data-image'));
            quickViewFeatureLoading.show();
            quickViewFeatureImage.load(function(e) {
              quickViewFeatureLoading.hide();
              $(this).unbind('load');
              quickViewFeatureLoading.hide();
            });
          }
          quickViewCarousel.find('a').removeClass('actived');
          $(this).addClass('actived');
        });

        quickViewCarousel.owlCarousel({
          items: 1,
          navText: ['',''],
          nav: true,
          margin: 10,
          dots: false
        });

      } else {
        quickviewTemplate.find('.quickview-more-views').remove();
        quickviewTemplate.find('.quickview-more-view-wrapper-jcarousel').remove();
      }
    },

    updatePricingQuickview= function() {
      var regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;
      var unitPriceTextMatch = $('.quick-view .price').text().match(regex);

      if (!unitPriceTextMatch) {
        regex = /([0-9]+[.|,][0-9]+)/g;
        unitPriceTextMatch = $('.quick-view .price').text().match(regex);
      }

      if (unitPriceTextMatch) {
        var unitPriceText = unitPriceTextMatch[0];
        var unitPrice = unitPriceText.replace(/[.|,]/g, '');
        var quantity = parseInt($('.quick-view input[name=quantity]').val());
        var totalPrice = unitPrice * quantity;

        var totalPriceText = Shopify.formatMoney(totalPrice, window.money_format);
        regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;     
        if (!totalPriceText.match(regex)) {
          regex = /([0-9]+[.|,][0-9]+)/g;
        } 
        totalPriceText = totalPriceText.match(regex)[0];
       
        var regInput = new RegExp(unitPriceText, "g");
        var totalPriceHtml = $('.quick-view .price').html().replace(regInput, totalPriceText);

        $('.quick-view .total-price span').html(totalPriceHtml);
        if( $('.currency-Picker').length > 0){
          Currency.convertAll(window.shop_currency, jQuery('select[name=currencies] option:selected').val(), '.quick-view span.money', 'money_format');
        }
      }
    },

    createQuickViewVariants= function(product, quickviewTemplate) {
			var result = '';
			var currentVariant = product.variants[0];
            for (var i = 0; i < product.variants.length; i++) {
              var variant = product.variants[i];
              var option = '<option value="' + variant.id + '">' + variant.title + '</option>';
              quickviewTemplate.find('form.variants > select').append(option);
            }    
			if (product.options[0].name !== 'Title') {
				var options = product.options;
				for (var i = 0; i < options.length; i ++) {
					var option = options[i];
					var optionIndex = i + 1;
					var type = 'label';
					var size = 30;
					if (window.settings.filter_name_1 === option.name) {
						type = window.settings.select_filter_1;
					}else if (window.settings.filter_name_2 === option.name) {
						type = window.settings.select_filter_2;
					}else if (window.settings.filter_name_3 === option.name) {
						type = window.settings.select_filter_3;
					}
					result += '<div class="variants-wrapper product-form__item '+ type +'" data-quickview-variant-option="' + optionIndex + '">';
					result += '<label class="variants__label">' + option.name + ': <span></span></label>';
					result += '<div class="variants__options">';
					if (window.settings.quickViewVariantType === 'select') {
						result += '<select class="js-quickview-option-selector product-form__input" data-id="quickViewOptionSelector-' + optionIndex + '" data-index="option' + optionIndex + '">';
						for (var j = 0; j < option.values.length; j ++) {
							var value = option.values[j];
							result += '<option value="' + _.escape(value) + '" ';
							result += currentVariant.options[i] === value ? 'selected="selected"' : '';
							result += '>' + value + '</option>';
						}
						result += '</select>';
					} else if (window.settings.quickViewVariantType === 'radio') {
						for (var j = 0; j < option.values.length; j ++) {
							var value = option.values[j];
							var isDisable = true;
							var isVariantsImage = false;
							var colorAttribute = '';
							// CHECK Product option is available or disabled       
							for (var k = 0; k < product.variants.length; k ++) {
								var variantCondition = product.variants[k];
								if (variantCondition.available) {
									if (i == 0 && variantCondition.option1 === value) {
										isDisable = false;
										break;
									} else if (i == 1 && variantCondition.option2 === value && variantCondition.option1 == currentVariant.option1) {
										isDisable = false;
										break;
									} else if (i == 2 && variantCondition.option3 === value && variantCondition.option2 == currentVariant.option2 && variantCondition.option1 == currentVariant.option1) {
										isDisable = false;
										break;
									}
								}
							}
							for (var e = 0; e < product.media.length; e ++) {
								var media_arr = product.media[e] ;
								var media_alt = media_arr.alt;
								if( media_alt ){
									var alt = media_alt.split('-');
								}
								if( alt && alt[1] == value ){
									isVariantsImage = true;
									break;
								}
							}
							// RENDER Product option button
							if( isVariantsImage ){
								for (var e = 0; e < product.media.length; e ++) {
									var media_arr = product.media[e] ;
									var media_alt = media_arr.alt;
									if( media_alt ){
										var alt = media_alt.split('-');
									}
									if( alt[1] == value ){
										var background = media_arr.src;
										result += '<div class="single-option-selector">';
										result += '<input type="radio" data-single-option-button';
										result += currentVariant.options[i] === value ? ' checked ' : ' ';
										if (isDisable) {
											result += 'disabled="disabled"';
										}
										result += 'value="' + _.escape(value) + '" data-index="option' + optionIndex + '" name="option' + option.position + '" ';
										result += 'class="js-quickview-option-selector';
										if (isDisable) {
											result += ' disabled';
										}
										result += '" id="quickview-product-option-' + i + '-' + value.toLowerCase() + '">';
										result += '<label data-toggle="tooltip" title="' + value + '" for="quickview-product-option-' + i + '-' + value.toLowerCase() + '" ' + colorAttribute;
        								if (isDisable) {
        									result += ' class="disabled ' + value + '"';
        								} else {
                                            result += ' class="' + value + '"';
                                        }                                      
										result += 'style="background:url('+ background +');background-size: cover;background-position: center;">' + value + '<span class="d-none"></span></label>';
										result += '</div>';
										break;
									}
								}
							}else{                            
								result += '<div class="single-option-selector">';
								result += '<input type="radio" data-single-option-button';
								result += currentVariant.options[i] === value ? ' checked ' : ' ';
								if (isDisable) {
									result += 'disabled="disabled"';
								}
								result += 'value="' + _.escape(value) + '" data-index="option' + optionIndex + '" name="option' + option.position + '" ';
								result += 'class="js-quickview-option-selector';
								if (isDisable) {
									result += ' disabled';
								}
								result += '" id="quickview-product-option-' + i + '-' + value.toLowerCase() + '">';
								result += '<label  data-toggle="tooltip" title="' + value + '" for="quickview-product-option-' + i + '-' + value.toLowerCase() + '" ' + colorAttribute;
								if (isDisable) {
									result += ' class="disabled ' + value + '"';
								} else {
                                    result += ' class="' + value + '"';
                                }
								result += '>' + value + '<span class="d-none"></span></label>';
								result += '</div>';
							}
						}
					}
					result += '</div>';
					result += '</div>';
				}
			}
			return result;
    },

    convertToSlug= function(text) {
      return text.toLowerCase().replace(/[^a-z0-9 -]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-');
    },

    switchImage= function (src, imgObject, el) {
      var $el = $(el);
      $el.attr('src', src);
    },

    initCurenty= function(){
      $('.currency-Picker .drop-left a').on('click', function(e) { 
        $("select.currency-picker").val($(this).data('value')).change();       
        if($(this).closest('.drop-left').find('li').hasClass('active')){
          $('li').removeClass('active');
        }
        $(this).closest('li').addClass('active');  
        e.preventDefault();
      }); 
      
      $('.currency-Picker .dropdown-content a').on('click', function(e) { 
        $("select.currency-picker").val($(this).data('value')).change();
        $(this).closest('.dropdown-content').removeClass('active');     
        e.preventDefault();
      }); 
      $('.dropdown-toggle > a').click(function() {    
        if($(this).closest('.dropdown-toggle').find('.dropdown-content').hasClass('active')){
          $('.dropdown-content').removeClass('active');
        }else{
          $('.dropdown-content').removeClass('active');
          $(this).closest('.dropdown-toggle').find('.dropdown-content').addClass('active');  
        }     
        return false;              
      }); 
   $('.language-currency [data-value="'+$('select[name=currencies] option:selected').val()+'"]').parent().addClass('active'); 
      $(document).on('click', function(e) {
        if ($('.dropdown-content').hasClass('active')) {
          $('.dropdown-content').toggleClass('active');
        }
      });
    },

    initaddjs= function(){
      $('body').on('change', '#minicart-sidebar .item input', function(e) {  
			$('#minicart-sidebar').addClass('load_modal');
			var id = $(this).data('product_id');
			var qty = $(this).val();
            var line = $(this).data('line');
            setTimeout(function() {
                ShopifyAPI.changeItem(line, qty , false );
            }, 250);  
	  });   

  	  $('body').on('click', '.minicart-header .btn-remove', function(e) {
  			var $el = $(this),
  				line = $el.data('line');
  			if (line) {
  				$('.minicart__product[data-line="' + line + '"]').addClass('is-loading');
  				setTimeout(function() {
  					ShopifyAPI.changeItem(line, 0 , false );
  				}, 250);
  			}
  	  });       
      $(document).ready(function() {
            // Lấy tất cả các mục accordion
            const items = $('.widget-tab-collection .card');
            let currentIndex = 0;
            let autoSwitchTimeout;  
            autoSwitch();
            // Xử lý sự kiện hover trên các card-header
            $('.widget-tab-collection .card').hover(          
                  function(e) {
                      if(!$(this).hasClass('active')) {
                          e.preventDefault();
                          clearTimeout(autoSwitchTimeout);
                          $('.widget-tab-collection .card').removeClass('active'), 
                          $(this).addClass('active');                   
                          // Khi hover: mở mục hiện tại, đóng các mục khác
                          var target = $(this).find('.btn-link').attr('data-target');
                          var image = $(this).find('.btn-link').attr('data-image');
                          $(".accordion-collection-image").each(function(e){
                              var id = $(this).attr('id');
                              if(id == image) {
                                $('#'+id).addClass('show');
                                $('#'+id).removeClass('hidden');
                              } else {
                                $('#'+id).removeClass('show');
                                $('#'+id).addClass('hidden');
                              }
                          })
                          
                          $(target).collapse('show');
                          currentIndex = $(this).closest('.card').index();
                          autoSwitch();                        
                      }
                  },
                  function() {
                  }
            ); 

            // Hàm tự động chuyển mục
            function autoSwitch() {
                // Đóng tất cả các mục
                $('.widget-tab-collection .collapse').collapse('hide');
                $('.widget-tab-collection .card').removeClass('active');  
                items.eq(currentIndex).addClass('active');             
                // Mở mục hiện tại
                const target = items.eq(currentIndex).find('.btn-link').attr('data-target');
                const image =  items.eq(currentIndex).find('.btn-link').attr('data-image');
                $(".accordion-collection-image").each(function(e){
                    var id = $(this).attr('id');
                    if(id == image) {
                        $('#'+id).addClass('show');
                        $('#'+id).removeClass('hidden');
                    } else {
                        $('#'+id).removeClass('show');
                        $('#'+id).addClass('hidden');
                    }
                })              
                $(target).collapse('show');
                $(target).addClass('show');

                // Tăng chỉ số, quay lại 0 nếu đến cuối
                currentIndex = (currentIndex + 1) % items.length;

                // Đặt timeout để chuyển mục tiếp theo sau 3 giây mà không delay thêm
                autoSwitchTimeout = setTimeout(autoSwitch, 3500);
            }        
        
        // Fix bug mobile owl
        jQuery.event.special.touchstart = {
          setup: function(_, ns, handle) {
            this.addEventListener("touchstart", handle, { passive: false });
          }
        };
        jQuery.event.special.touchmove = {
          setup: function(_, ns, handle) {
            this.addEventListener("touchmove", handle, { passive: false });
          }
        };
        // Fix bug mobile owl    
        $('.live-chat').click(function() {
			$('.ss-fb-ms-inner').show();
		});
    	$(".title-size-chart").on( "click", function() {
    		if($('.size-chart').hasClass('active')){
    			$('.size-chart').removeClass('active');	
                $("body").removeClass('overflow_hidden');
    		}else{
    			$('.size-chart').addClass('active');		
                $( ".product__info-media" ).css("position","relative");
                $( ".product__info-container" ).css("position","relative"); 
                $("body").addClass('overflow_hidden');
    		}
    	});        
        $('.ss-fb-message-style-default').click(function() {
			$('.ss-fb-ms-inner').show();
			$(this).hide();
		});
         $('.ss-fb-message-style-metro').click(function() {
			$('.ss-fb-ms-inner').show();
			$(this).hide();
		});
        $('.ss-fb-message-style-icon').click(function() {
      		$('.ss-fb-ms-inner').fadeToggle(300);
      		$(this).toggleClass('open');
      	});
        $('.offline_heading').click(function() {
			$('.ss-fb-ms-inner').hide();
			$('.ss-fb-ms-bottom').show();
		});
        
        $('.minicart-header .shopcart.drawer').click(function() {
         $('.block-content').addClass('open');
           $('.cart-overlay').addClass("open");
           $("html").toggleClass("no-scroll");
        });
        $('.cart-remove').click(function(e){
          e.preventDefault();
          $('.block-content').removeClass("open");
          $('.cart-overlay').removeClass("open");
          $("html").removeClass("no-scroll");
        });
        $('.cart-overlay').click(function(e){
          e.preventDefault();
          $(this).toggleClass("open");
          $('.block-content').removeClass("open");
          $("html").removeClass("no-scroll");
        });
        
        $(".search-wrap .icon-search").click(function(){
          $('.search-wrap').toggleClass("open");
          $("html").toggleClass("no-scroll");
		});
		$(".search-wrap .overlay").click(function(){
          $('.search-wrap').toggleClass("open");
          $("html").removeClass("no-scroll");
		}); 

        $('.search-wrap .icon-close').click(function() {
          $('.search-wrap').removeClass('open');
          $("html").removeClass("no-scroll");
        });
        
        $('.section-announcement-bar .button-close').click(function() {
          $(this).toggleClass('active');
          $('#shopify-section-announcement-bar').slideToggle(300);
        });
        
        $('.header-center *[data-target="popup"]').on('click', function() {
          $('html').addClass('overflow-pop');
          $('html').removeClass('overflow-pop-register');
          $('.popup').animate({
            scrollTop:'0px'
          }, 500);
        });
        
         $('.toogle_content2').on('click', function() {
            $('html').removeClass('overflow-pop');
         });
         $('.toogle_content3').on('click', function() {
            $('html').removeClass('overflow-pop-register');
         });
		
        $('.header-center *[data-target="popup-close"]').on('click', function() {
          $('html').removeClass('overflow-pop');
          $($(this).attr('data-popup-close')).addClass('popup-hidden');
        });
        
        // close , open side bar
        $(".open-sidebar").click(function(e){
          $(".sidebar-overlay").toggleClass("show");
          $(".sidebar-fixed").toggleClass("active");
          $("html").toggleClass("no-scroll");
        });
        $( ".open-fiter" ).click(function() {
          $('.sidebar-fixed').slideToggle(200);
          $(this).toggleClass('active');
        });        
        $(".sidebar-overlay").click(function(e){
          $(".sidebar-overlay").toggleClass("show");
          $(".sidebar-fixed").toggleClass("active");
          $("html").removeClass("no-scroll");
        });
        $('#close-sidebar').click(function() {
          $('.sidebar-overlay').removeClass('show');
          $('.sidebar-fixed').removeClass('active');   
          $("html").removeClass("no-scroll");
        });

        //close open account
        $(".header__account .login-account_popup").click(function(e){
          $(".popup-overlay").toggleClass("active");
          $(".login-popup").toggleClass("active");
          $("html").toggleClass("no-scroll");
        });              
        $(".popup-overlay").click(function(e){
          $(".popup-overlay").toggleClass("active");
          $(".login-popup").toggleClass("active");
          $("html").removeClass("no-scroll");
        });
        $('.close-popup-login').click(function() {
          $('.popup-overlay').removeClass('active');
          $('.login-popup').removeClass('active');
          $("html").removeClass("no-scroll");
        });

        //show login or register or forget-password
        $(".login-popup .button-account").click(function(e){
          e.preventDefault();
          $(".tab-popup").addClass("hidden");
          $(".login-popup .register-form").removeClass('hidden');    
        });  
        $(".login-popup .button-login").click(function(e){
          e.preventDefault();
          $(".tab-popup").addClass("hidden");
          $(".login-popup .login-form").removeClass('hidden');    
        });  
        $(".login-popup .forget-password").click(function(e){
          e.preventDefault();
          $(".tab-popup").addClass("hidden");
          $(".login-popup .recover-password").removeClass('hidden');    
        });       
      
        //show pass or not
        $('.password-toggle').click(function (e) {       
            e.preventDefault();
            var $this = $(this);
            var $passwordField = $this.siblings('.form-control');
            var isShow = $this.hasClass("password-toggle--show") ? true : false;
            if (isShow) {
                $this.removeClass("password-toggle--show");
                $passwordField.attr('type', 'password');
            } else {
                $this.addClass("password-toggle--show");
                $passwordField.attr('type', 'text');
            }
        });
      
        //search page all Blog
        $('.view-mode button').bind("click", function() {
          $(this).parent().find('button').removeClass('active');
          $(this).addClass('active');
        }); 
        // Blog List
        $('#list-view').click(function() {
          $('.blogs-listing .blog-layout').attr('class', 'blog-layout list__item col-sm-12 col-12');
          localStorage.setItem('listview', 'list');
        });
        // Blog Grid apply for search page  
        $('#grid-5').click(function() {
          $('.blogs-listing .blog-layout').attr('class', 'blog-layout grid__item col-xl-15 col-lg-15 col-md-4 col-sm-4 col-12');
          localStorage.setItem('listview', 'grid-5');
        });
        $('#grid-4').click(function() {
          $('.blogs-listing .blog-layout').attr('class', 'blog-layout grid__item col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12');
          localStorage.setItem('listview', 'grid-4');
        });
        $('#grid-3').click(function() {
          $('.blogs-listing .blog-layout').attr('class', 'blog-layout grid__item col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12');
          localStorage.setItem('listview', 'grid-3');
        });
        $('#grid-2').click(function() {
          $('.blogs-listing .blog-layout').attr('class', 'blog-layout grid__item col-xl-6 col-lg-6 col-md-6 col-sm-4 col-12');
          localStorage.setItem('listview', 'grid-2');
        });
        if (localStorage.getItem('listview') == 'grid-2'){
          $('#grid-2').trigger('click');
        }else if (localStorage.getItem('listview') == 'grid-5'){
          $('#grid-5').trigger('click');
        }else if (localStorage.getItem('listview') == 'grid-4'){
          $('#grid-4').trigger('click');
        }else if (localStorage.getItem('listview') == 'grid-3'){
          $('#grid-3').trigger('click');
        }else if (localStorage.getItem('listview') == 'list'){
          $('#list-view').trigger('click');
        }else {
          $('#grid-6').trigger('click');
        }
        
        // counter bootstrap
    	$('.js-counter').each(function () {
            $(this).prop('Counter',0).animate({
                Counter: $(this).text()
            }, {              
              //change count up speed here
                duration: 5000,
                easing: 'swing',
                step: function (now) {
                    $(this).text(Math.ceil(now));
                }
            });
        });

        $(document).ready(function() {
            $(".popup-gallery").fancybox();
        }); 
        $(document).ready(function() {
           var heightbanner = $(".widget-tab-collection .images-collection").height();
           $(this).find('.widget-tab-collection .tab-collection').css({'height': heightbanner});
        });            
        const windowWidth = window.innerWidth || document.documentElement.clientWidth;
        $('.filter-category a').on("click", function () {
          var number = $(this).find('span').html();
          $('.product-count').text(number + ' products');
        });  
        $('.dropdown-toggle').on("click", function (e) {
          $('.dropdown-content').stop().slideUp(300);
          $(this).next().stop().slideToggle(300);
          e.preventDefault();
        }); 
        $('.dropdown-content li').on("click", function (e) {
          $(this).parent().slideUp(300);
        }); 

        $(".fixed-scr").stick_in_parent({
          offset_top: 10
        });
         $(document).on("click",".so-groups-sticky .popup-close", function(){
          $(".so-groups-sticky").toggleClass("active");
        });
         $('.close-cart').click(function() {
          $('.add-to-cart-fixed').fadeOut(500);
        }); 
        
        //PRODUCT TAB
        $(".widget-product-tabs-horizontal").each( function(){
          $(this).find('.tabs-title li:first-child').addClass('current');
          $(this).find('.tab-content').first().addClass('current');

          $(this).find('.tabs-title li').click(function(e){ 
            var tab_id = $(this).attr('data-tab');
            var url = $(this).attr('data-url');
            $(this).closest('.widget-product-tabs-horizontal').find('.tab-viewall').attr('href',url);
            $('.tabs-title').toggleClass("tabs-open");
            $(this).closest('.widget-product-tabs-horizontal').find('.tabs-title li').removeClass('current');
            $(this).closest('.widget-product-tabs-horizontal').find('.tab-content').removeClass('current');

            $(this).addClass('current');
            $(this).closest('.widget-product-tabs-horizontal').find("#"+tab_id).addClass('current');
            e.preventDefault();
          }); 
          $('.open-title-menu').click(function(e){
            e.preventDefault();
            $('.tabs-title').toggleClass("tabs-open");
          }); 
        }); 

        //toggle-menu
        $('.toggle-menu .caret').click(function(e){
          e.preventDefault(); 
          $(this).parent().next().slideToggle("fast");
          return false;      
        });

        $("#goToTop").addClass("hidden-top");
        $(window).scroll(function () {
          if ($(this).scrollTop() === 0) {
            $("#goToTop").addClass("hidden-top")
          } else {
            $("#goToTop").removeClass("hidden-top")
          }
        });

        $('#goToTop').click(function () {
          $('body,html').animate({scrollTop:0}, 1200);
          return false;
        });

        $("#loadingSite").fadeOut("slow");

        //GALLERY PRODUCT
        $('.product-card__gallery .item-img').on("mouseover touchstart", function (e) {
          $(this).addClass('thumb-active').siblings().removeClass('thumb-active');
          var thumb_src = $(this).attr("data-src");
          $(this).closest('.product-item-container').find('.img-responsive.s-img').attr("src",thumb_src);
        });
           
    
		/* ===================================
              WOW Animation
          ====================================== */

          if ($(window).width() > 991) {
              var wow = new WOW({
                  boxClass: 'wow',
                  animateClass: 'animated',
                  offset: 0,
                  mobile: false,
                  live: true
              });
              new WOW().init();
          }
        //OFFCANVAS MENU
        $('.mob-menu').click(function(e){
          e.preventDefault();
          $('.mobile-menu').toggleClass("nav-open");
          $('.mobile-screen').addClass("nav-open");
          $("html").toggleClass("no-scroll");
        });
        $('.mobile-screen').click(function(e){
          e.preventDefault();
          $(this).toggleClass("nav-open");
          $('.mobile-menu').removeClass("nav-open");
           $("html").removeClass("no-scroll");
        });
        $('.menu-remove').click(function(e){
          e.preventDefault();
          $('.mobile-screen').removeClass("nav-open");
          $('.mobile-menu').removeClass("nav-open");
          $("html").removeClass("no-scroll");
        });
        //BONUS PAGE
        $("ul.yt-accordion li").each(function() {
          if($(this).index() > 0) {
            $(".yt-accordion-inner").hide();
            $(".enable+.yt-accordion-inner").show();
            $(".enable+.yt-accordion-inner").addClass("active");
          }
          else {
            $(".enable").addClass('active');
          }
          var ua = navigator.userAgent,
              event = (ua.match(/iPad/i)) ? "touchstart" : "click";
          $(this).children(".accordion-heading").bind(event, function() {

            if($(this).hasClass("active"))
            {
              $(this).removeClass("active");
              $(this).siblings(".yt-accordion-inner").removeClass("active");
              $(this).siblings(".yt-accordion-inner").slideUp(350);
            }
            else
            {
              $(this).addClass("active");
              $(this).siblings(".yt-accordion-inner").addClass("active");
              $(this).siblings(".yt-accordion-inner").slideDown(350);
            }

            $(this).parent().siblings("li").children(".yt-accordion-inner").slideUp(350);
            $(this).parent().siblings("li").find(".active").removeClass("active");
          });
        });

      });
    },

    initScrolling= function(){
      $('.loadmore').click(function(e) {
        e.preventDefault(); 
      });
    },

    reinitView= function() {
      $('.view-mode button').bind("click", function() {
        $(this).parent().find('button').removeClass('active');
        $(this).addClass('active');
      }); 
      // Product List
      $('#list-view').click(function() {
        $('.products-listing .product-layout').attr('class', 'product-layout list__item col-sm-12 col-12');
        localStorage.setItem('listview', 'list');
      });
      // Product Grid
      $('#grid-5').click(function() {
        $('.products-listing .product-layout').attr('class', 'product-layout grid__item product-grid-5 col-xl-15 col-lg-15 col-md-4 col-sm-4 col-12');
        localStorage.setItem('listview', 'grid-5');
      });
      $('#grid-4').click(function() {
        $('.products-listing .product-layout').attr('class', 'product-layout grid__item col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12');
        localStorage.setItem('listview', 'grid-4');
      });
      $('#grid-3').click(function() {
        $('.products-listing .product-layout').attr('class', 'product-layout grid__item col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12');
        localStorage.setItem('listview', 'grid-3');
      });
      $('#grid-2').click(function() {
        $('.products-listing .product-layout').attr('class', 'product-layout grid__item col-xl-6 col-lg-6 col-md-6 col-sm-4 col-12');
        localStorage.setItem('listview', 'grid-2');
      });
      if (localStorage.getItem('listview') == 'grid-2'){
        $('#grid-2').trigger('click');
      }else if (localStorage.getItem('listview') == 'grid-5'){
        $('#grid-5').trigger('click');
      }else if (localStorage.getItem('listview') == 'grid-4'){
        $('#grid-4').trigger('click');
      }else if (localStorage.getItem('listview') == 'grid-3'){
        $('#grid-3').trigger('click');
      }else if (localStorage.getItem('listview') == 'list'){
        $('#list-view').trigger('click');
      }else {
        $('#grid-6').trigger('click');
      }
    },
    
    productsTabs= function() {
      $('.widget-product-tabs-horizontal').each(function() {
        var $this = $(this),
            $inner = $this.find('.tabs-content'),
            cache = [];

        $this.find('.tabs-menu_title li').on('click', function(e) {
          e.preventDefault();
          
          var $this = $(this),
              datasection = $(this).parent().data('section'),
              ajaxurl = $this.data('atts'),
              index = $this.index(),
          	  value = $this.data('value'),
              dataidblock = $this.data('idblock');
           $("select.tabs-menu_btn").val($(this).data('value')).change();

          $('.widget-product-tabs-horizontal .tabs-content .tab-content').each(function() {
            
                if(this.id == 'tab-'+dataidblock) {
                    $('#'+this.id).addClass('active');
                    $('#'+this.id).removeClass('no-active');
                } else {
                    $('#'+this.id).addClass('no-active');
                    $('#'+this.id).removeClass('active');                 
                }
          });
        });

        var $nav = $this.find('.tabs-menu'),
            $subList = $nav.find('ul'),
            time = 300;

        $nav.on('click', '.open-title-menu', function() {
          var $btn = $(this);

          if( $subList.hasClass('list-shown') ) {
            $('.box-sellect').removeClass('open');
            $btn.removeClass('toggle-active');
            $subList.removeClass('list-shown');
          } else {
             $('.box-sellect').addClass('open');
            $btn.addClass('toggle-active');
            $subList.addClass('list-shown');
            setTimeout(function() {
              $('body').one('click', function(e) {
                var target = e.target;
                if ( ! $(target).is('.tabs-menu') && ! $(target).parents().is('.tabs-menu')) {
                  $btn.removeClass('toggle-active');
                  $subList.removeClass('list-shown');
                  $('.box-sellect').removeClass('open');
                  return false;
                }
              });
            },10);
          }

        })

        .on('click', 'li', function() {
          var $btn = $nav.find('.open-title-menu'),
              text = $(this).text();

          if( $subList.hasClass('list-shown') ) {
            $subList.removeClass('list-shown');
            $('.box-sellect').removeClass('open');
          }
        });

      });   

      var loadTab = function(ajaxurl, index, holder, btn, cache, callback) {
        btn.parent().find('.active-tab-title').removeClass('active-tab-title');
        btn.addClass('active-tab-title')
        holder.addClass('loading').parent().addClass('element-loading');
        btn.addClass('loading');

        $.ajax({
          dataType: "html",
          type: 'GET',
          url: ajaxurl,
          success: function(data) {
            //cache[index] = data;
            callback( data );
          },
          error: function(data) {
            console.log('ajax error');
          },
          complete: function() {            
            $('.product-card__gallery .item-img').on("mouseover touchstart", function (e) {
              $(this).addClass('thumb-active').siblings().removeClass('thumb-active');
              var thumb_src = $(this).attr("src");
              $(this).closest('.product-item-container').find('.img-responsive.s-img').attr("src",thumb_src);
            });

            initCountd();
            initlOwlCarousel();
            initcolor();
            initButtonsWishlist();
            //product review
            $.getScript("https://cdn.shopify.com/extensions/0ac0efc5-cc12-443a-9f35-934e5177704c/product-review-myappgurus-165/assets/productReview.js");
            
            if( $(".spr-badge").length > 0 ) {
              $.getScript(window.location.protocol + "//productreviews.shopifycdn.com/assets/v4/spr.js");
              
            }
            holder.removeClass('loading').parent().removeClass('element-loading');
            btn.removeClass('loading');
          },
        });
      };
    },

    productsTabsDetail= function() {
      $('.tab-hozizoltal').each(function() {
        var $this = $(this),
            $inner = $this.find('.tabs-content'),
            cache = [];

        $this.find('.tabs-menu_title li').on('click', function(e) {
          e.preventDefault();

          var $this = $(this),
              ajaxurl = $this.data('atts'),
              index = $this.index(),
          	  value = $this.data('value'),
              dataidblock = $this.data('idblock');
           $("select.tabs-menu_btn").val($(this).data('value')).change();


          $('.products-listing .tabs-content .tab-content').each(function() {
            
                if(this.id == 'tab-'+dataidblock) {
                    $('#'+this.id).addClass('active');
                    $('#'+this.id).removeClass('hidden');
                } else {
                    $('#'+this.id).addClass('hidden');
                    $('#'+this.id).removeClass('active');                 
                }
              $('html, body').animate({ scrollTop: $('.products-listing').offset().top }, 500);
          });          
          
          //loadTab(ajaxurl, index, $inner, $this, cache,  function(data) {
          //  $inner.html(data);
          //});

        });

        var $nav = $this.find('.tabs-menu'),
            $subList = $nav.find('ul'),
            time = 300;

        $nav.on('click', '.open-title-menu', function() {
          var $btn = $(this);

          if( $subList.hasClass('list-shown') ) {
            $('.box-sellect').removeClass('open');
            $btn.removeClass('toggle-active');
            $subList.removeClass('list-shown');
          } else {
             $('.box-sellect').addClass('open');
            $btn.addClass('toggle-active');
            $subList.addClass('list-shown');
            setTimeout(function() {
              $('body').one('click', function(e) {
                var target = e.target;
                if ( ! $(target).is('.tabs-menu') && ! $(target).parents().is('.tabs-menu')) {
                  $btn.removeClass('toggle-active');
                  $subList.removeClass('list-shown');
                  return false;
                }
              });
            },10);
          }

        })

        .on('click', 'li', function() {
          var $btn = $nav.find('.open-title-menu'),
              text = $(this).text();

          if( $subList.hasClass('list-shown') ) {
            $subList.removeClass('list-shown');
          }
        });

      });

      var loadTab = function(ajaxurl, index, holder, btn, cache, callback) {
        btn.parent().find('.active-tab-title').removeClass('active-tab-title');
        btn.addClass('active-tab-title')
        holder.addClass('loading').parent().addClass('element-loading');
        btn.addClass('loading');

        $.ajax({
          dataType: "html",
          type: 'GET',
          url: ajaxurl,
          success: function(data) {
            //cache[index] = data;
            callback( data );
          },
          error: function(data) {
            console.log('ajax error');
          },
          complete: function() {            
            $('.product-card__gallery .item-img').on("mouseover touchstart", function (e) {
              $(this).addClass('thumb-active').siblings().removeClass('thumb-active');
              var thumb_src = $(this).attr("src");
              $(this).closest('.product-item-container').find('.img-responsive.s-img').attr("src",thumb_src);
            });

            initCountd();
            initlOwlCarousel();
            initcolor();
            initButtonsWishlist();
            //product review
            $.getScript("https://cdn.shopify.com/extensions/0ac0efc5-cc12-443a-9f35-934e5177704c/product-review-myappgurus-165/assets/productReview.js");
            
            if( $(".spr-badge").length > 0 ) {
              $.getScript(window.location.protocol + "//productreviews.shopifycdn.com/assets/v4/spr.js");
              
            }
            holder.removeClass('loading').parent().removeClass('element-loading');
            btn.removeClass('loading');
          },
        });
      };
    },
	
    ConvertCurrency= function() {
      return window.show_multiple_currencies && Currency.currentCurrency != shopCurrency;
    },
     initInfiniteScrollingHomepage= function () {
      var newArrivalsProduct = $('[data-new-arrivals-product]');

      newArrivalsProduct.each(function () {
        var self = $(this);
        var infiniteScrolling = self.find('.infinite-scrolling-homepage');
        var infiniteScrollingLinkSlt = self.find('.infinite-scrolling-homepage a');
            
        if (infiniteScrolling.length) {
          infiniteScrollingLinkSlt.off('click.showMoreProduct').on('click.showMoreProduct', function (e) {
            e.preventDefault();
            e.stopPropagation();
            if($(this).hasClass('ajax-loading') )
              return false;
            $(this).addClass('ajax-loading');
            var url = $(this).attr('data-collection'),
                limit = $(this).attr('data-limit'),
                page = parseInt($(this).attr('data-page'));

            if (!$(this).hasClass('disabled')) {
              doAjaxInfiniteScrollingGetContentSection(url,limit,page,e,self);
            };
          });
        }
      });
    },
  
    doAjaxInfiniteScrollingGetContentSection= function(url,limit,page,e,self) {
      $.ajax({
        type: "get",
        url: window.router + '/collections/' + url,
        cache: false,
        data: {
          view: 'sorting',
          constraint: 'limit=' + limit + '+page=' + page
        },

        beforeSend: function () {
          showLoading();
       
        },
        success: function (data) {
          self.find('.product-item').append(data);
          if( $(data).length == limit ){
            $(e.currentTarget).attr('data-page', page + 1);
          }
          else{
            $(e.currentTarget).attr('disabled','disabled');
            $(e.currentTarget).addClass('disabled');
            $(e.currentTarget).text(window.inventory_text.no_more_product);
          }
          initQuickView();
          initAddToCart();
          initButtonsWishlist();
          if (checkNeedToConvertCurrency()) {
            Currency.convertAll(window.shop_currency, jQuery('.currencies').val(), 'span.money', 'money_format');
          }
          if ($('.shopify-product-reviews-badge').length && $('.spr-badge').length) {
            return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
          };

        },
        complete: function () {
          hideLoading();
          $(e.currentTarget).removeClass('ajax-loading');
          $('.infinite-scrolling1').remove();
        }
      });
    },
    initcolor= function(){ 
      $( ".product-item .swatch-list li:first-child" ).addClass('active');
        $( ".product-item .swatch-list li" ).click(function(e) {
          e.preventDefault();
          
          $(this).parent().find('li').removeClass('active');
           $(this).addClass('active'); 
          var link = $(this).find('a').data('image');
          $(this).parent().prev().find('img').attr('src',link);   
        });
    }   
  }
  })(jQuery);

//wishlist
const LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
const LOCAL_STORAGE_DELIMITER = ',';
const BUTTON_ACTIVE_CLASS = 'active';
const GRID_LOADED_CLASS = 'loaded';
const selectors = {
  button: '.action-link >.add-in-wishlist-js',
  grid: '[grid-wishlist]',
  productCard: '.product-content-wishlist',
};
document.addEventListener('DOMContentLoaded', () => {
    if ($('body').hasClass('template-product') ) {
    } else {
      initButtonsWishlist();
    }   
	initGrid();
	const wishlist = getWishlist();
	$('.header__wishlist span').html(wishlist.length);
});
document.addEventListener('shopify-wishlist:updated', (event) => {
	initGrid();
});
const fetchProductCardHTML = (handle) => {
  const productTileTemplateUrl = `/products/${handle}?view=wishlist`;
  return fetch(productTileTemplateUrl)
  .then((res) => res.text())
  .then((res) => {
    const text = res;
    const parser = new DOMParser();
    const htmlDocument = parser.parseFromString(text, 'text/html');
    const productCard = htmlDocument.documentElement.querySelector(selectors.productCard);
    return productCard.outerHTML;
  })
  .catch((err) => console.error(`[Shopify Content] Failed to load content for handle: ${handle}`, err));
};
const setupGrid = async (grid) => {
	const wishlist = getWishlist();
	const requests = wishlist.map(fetchProductCardHTML);
	const responses = await Promise.all(requests);
	const wishlistProductCards = responses.join('');
	grid.innerHTML = wishlistProductCards;
	grid.classList.add(GRID_LOADED_CLASS);
	initButtonsWishlist();
	initButtonsCompare();
    initCountd();
	smartaddonSS();
	smartaddonSS.click_atribute_image();
    reinitView();
	if( $('.currency-Picker').length > 0){
        Currency.convertAll(window.shop_currency, jQuery('select[name=currencies] option:selected').val(), 'span.money', 'money_format');
    }
	const event = new CustomEvent('shopify-wishlist:init-product-grid', {
		detail: { wishlist: wishlist }
	});
	document.dispatchEvent(event);
	$('.wishlist__grid').removeClass('loading_wishlist');
	if( wishlist.length > 0 ){
		$('.wishlist_empty').addClass('hidden');
	}else{
		$('.wishlist_empty').removeClass('hidden');
	}
};
const setupButtonsWishlist = (buttons) => {
	buttons.forEach((button) => {
		const productHandle = button.dataset.productHandle || false;
		if (!productHandle) return;
		if (wishlistContains(productHandle)) button.classList.add(BUTTON_ACTIVE_CLASS);		
		button.addEventListener('click', () => {
			const timeWishlist = setTimeout(loadWishlist, 1000);
			updateWishlist(productHandle);
			button.classList.add('load-wishlist');
			function loadWishlist() {
				button.classList.remove('load-wishlist');
				button.classList.toggle(BUTTON_ACTIVE_CLASS);
				if($(button).hasClass('active')){
					var $parent = button.closest('.action-link');
					button.setAttribute('data-title',window.strings.remove_wishlist);
				}else{
					var $parent = button.closest('.action-link');
					button.setAttribute('data-title',window.strings.wishlist);
				}
			}
		});
	});
};
const initGrid = () => {
	const grid = document.querySelector(selectors.grid) || false;
	if (grid) setupGrid(grid);
};
const initButtonsWishlist = ($element) => {
	if($element){
		const parentElement = document.querySelector($element);
		let buttons = parentElement.querySelectorAll(selectors.button) || [];
		if (buttons.length) setupButtonsWishlist(buttons);
		else return;
	}else{
		const buttons = document.querySelectorAll(selectors.button) || [];
		if (buttons.length) setupButtonsWishlist(buttons);
		else return;
	}
	const event = new CustomEvent('shopify-wishlist:init-buttons', {
		detail: { wishlist: getWishlist() }
	});
	document.dispatchEvent(event);
	$(selectors.button).each(function(event){
		if($(this).hasClass('active')){
			var $parent = $(this).closest('.product-wishlist');
			$parent.attr('data-title',window.strings.remove_wishlist);
		}else{
			var $parent = $(this).closest('.product-wishlist');
			$parent.attr('data-title',window.strings.wishlist);
		}
	});
};
const getWishlist = () => {
	const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
	if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
	return [];
};
const setWishlist = (array) => {
	const wishlist = array.join(LOCAL_STORAGE_DELIMITER);
	if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
	else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);
	const event = new CustomEvent('shopify-wishlist:updated', {
		detail: { wishlist: array }
	});
	document.dispatchEvent(event);
	return wishlist;
};
const updateWishlist = (handle) => {
	const wishlist = getWishlist();
	const indexInWishlist = wishlist.indexOf(handle);
	if (indexInWishlist === -1) 
		wishlist.push(handle);
	else 
		wishlist.splice(indexInWishlist, 1);
	$('.header__wishlist span').html(wishlist.length);
	return setWishlist(wishlist);
};
const wishlistContains = (handle) => {
	const wishlist = getWishlist();
	return wishlist.includes(handle);
};
const resetWishlist = () => {
	return setWishlist([]);
};
//compare
const LOCAL_STORAGE_COMPARE_KEY = 'shopify-compare';
const LOCAL_STORAGE_DELIMITER_COMPARE = ',';
const BUTTON_ACTIVE_CLASS_COMPARE = 'active';
const GRID_LOADED_CLASS_COMPARE = 'loaded';
const selectorscompare = {
	button: '.button-compare >button',
	remove: '.remove-compare >button',
	grid: '[grid-compare]',
	table: '.compare-page',
	productCard: '.product-content-compare',
};
document.addEventListener('DOMContentLoaded', () => {
    if ($('body').hasClass('template-product') ) {
       
    } else {
      initButtonsCompare();
    } 
	initGridCompare();
	const compare = getCompare();
	if(compare.length === 0){        
		$(selectorscompare.table).removeClass(GRID_LOADED_CLASS_COMPARE);
	}else{
		$(selectorscompare.table).addClass(GRID_LOADED_CLASS_COMPARE);
		$('.show-compare .count',selectorscompare.table).html(compare.length);
	}
});
document.addEventListener('shopify-compare:updated', (event) => {
	initGridCompare();
});
const fetchProductCardHTMLCOMPARE = (handle) => {
	const productTileTemplateUrl = `/products/${handle}?view=compare`;
	return fetch(productTileTemplateUrl)
	.then((res) => res.text())
	.then((res) => {
		const text = res;
		const parser = new DOMParser();
		const htmlDocument = parser.parseFromString(text, 'text/html');
		const productCard = htmlDocument.documentElement.querySelector(selectorscompare.productCard);
		return productCard.outerHTML;
	})
	.catch((err) => console.error(`[Shopify Content] Failed to load content for handle: ${handle}`, err));
};
const setupGridCompare = async (grid) => {
	const compare = getCompare();
	const requests = compare.map(fetchProductCardHTMLCOMPARE);
	if(requests){
		$.each( requests, function( key, result ){
			result.then(
				function(value) {
					const productRemove = new DOMParser().parseFromString(value, 'text/html').querySelector('.clone-remove-compare').innerHTML;
					$(".remove-button",selectorscompare.table).append('<div>'+productRemove+'</div>');
				},
				function(error) {
					console.log(error);
			});
		});
		$.each( requests, function( key, result ){
			result.then(
				function(value) {
					const productName = new DOMParser().parseFromString(value, 'text/html').querySelector('.clone-compare-title').innerHTML;
					$(".compare-product_name",selectorscompare.table).append('<div>'+productName+'</div>');
				},
				function(error) {
					console.log(error);
				});
		});
		$.each( requests, function( key, result ){
			result.then(
				function(value) {
					const productImage = new DOMParser().parseFromString(value, 'text/html').querySelector('.clone-compare-image').innerHTML;
					$(".compare-product_image",selectorscompare.table).append('<div>'+productImage+'</div>');
				},
				function(error) {
					console.log(error);
				});
		});
		$.each( requests, function( key, result ){
			result.then(
				function(value) {
					const productVariants = new DOMParser().parseFromString(value, 'text/html').querySelector('.clone-compare-card__content').innerHTML;
					$(".compare-product_variants",selectorscompare.table).append('<div>'+productVariants+'</div>');
				},
				function(error) {
					console.log(error);
				});
		});
		$.each( requests, function( key, result ){
			result.then(
				function(value) {
					const productAvailability = new DOMParser().parseFromString(value, 'text/html').querySelector('.clone-compare-inventory').innerHTML;
					$(".compare-product_availability",selectorscompare.table).append('<div>'+productAvailability+'</div>');
				},
				function(error) {
					console.log(error);
				});
		});
		$.each( requests, function( key, result ){
			result.then(
				function(value) {
					const productPrice = new DOMParser().parseFromString(value, 'text/html').querySelector('.clone-compare-price').innerHTML;
					$(".compare-product_price",selectorscompare.table).append('<div>'+productPrice+'</div>');
				},
				function(error) {
					console.log(error);
				});
		});
		$.each( requests, function( key, result ){
			result.then(
				function(value) {
					const productAtc = new DOMParser().parseFromString(value, 'text/html').querySelector('.clone-compare-atc').innerHTML;
					$(".compare-product_atc",selectorscompare.table).append('<div>'+productAtc+'</div>');
				},
				function(error) {
					console.log(error);
				});
		});	
        smartaddonSS();
        smartaddonSS.click_atribute_image();
	}
	const responses = await Promise.all(requests);
	const compareProductCards = responses.join('');
  
	$('body').on('submit', '.product-card__form [data-product-form]', function(evt) {
			evt.preventDefault();
            
            var formData = new FormData(evt.target);

            var image = $(".product-card__image_compare[data-handle="+formData.get("handle")+"] img").attr('src');
            doAjaxAddToCart(formData.get("id"), 1, formData.get("title"), image);
	});
  
	if(compare.length > 0 && $('.currency-Picker').length > 0){
		if( $('.currency-Picker').length > 0){
          Currency.convertAll(window.shop_currency, jQuery('select[name=currencies] option:selected').val(), 'span.money', 'money_format');
        }
	}
	removeCompare();
    smartaddonSS.click_atribute_image();
	const event = new CustomEvent('shopify-compare:init-product-grid', {
		detail: { compare: compare }
	});
	document.dispatchEvent(event);
};
const setupButtonsCompare = (buttons) => {
	buttons.forEach((button) => {
		const productHandle = button.dataset.productHandle || false;
		if (!productHandle) return;
		if (compareContains(productHandle)) button.classList.add(BUTTON_ACTIVE_CLASS_COMPARE);
		button.addEventListener('click', () => {
			if(!$(button).hasClass('active')){
				$('.content-compare',selectorscompare.table).addClass('active');
				$('.content',selectorscompare.table).addClass('load-compare');
			}
			const timeCompare = setTimeout(loadCompare, 1000);
			updateCompare(productHandle);
			button.classList.add('load-compare');
			function loadCompare() {
				button.classList.remove('load-compare');
				$('.content',selectorscompare.table).removeClass('load-compare');
				button.classList.toggle(BUTTON_ACTIVE_CLASS_COMPARE);
				if($(button).hasClass('active')){
					var $parent = button.closest('.button-compare');
					$parent.setAttribute('data-title',window.strings.remove_compare);
				}else{
					var $parent = button.closest('.button-compare');
					$parent.setAttribute('data-title',window.strings.compare);
				}
			}
			return ;
		});
	});
};
const removeButtonsCompare = (buttons) => {
	buttons.forEach((remove) => {
		const productHandle = remove.dataset.productHandle || false;
		if (!productHandle) return;
		if (compareContains(productHandle)) remove.classList.add(BUTTON_ACTIVE_CLASS_COMPARE);
		remove.addEventListener('click', () => {
			const timeCompare = setTimeout(loadCompare, 1000);
			updateCompare(productHandle);
			$('.content',selectorscompare.table).addClass('load-compare');
			function loadCompare() {
				$('.content',selectorscompare.table).removeClass('load-compare');
				var handle = remove.getAttribute('data-product-handle');
				$('.button-compare >button[data-product-handle='+handle+']').removeClass(BUTTON_ACTIVE_CLASS_COMPARE);
				$(selectorscompare.button).each(function(event){
					if($(this).hasClass('active')){
						var $parent = $(this).closest('.button-compare');
						$parent.attr('data-title',window.strings.remove_compare);
					}else{
						var $parent = $(this).closest('.button-compare');
						$parent.attr('data-title',window.strings.compare);
					}
				});
			}
		});
	});
}
const initGridCompare = () => {
	const grid = document.querySelector(selectorscompare.grid) || false;
	if (grid){
		$(".remove-button",selectorscompare.table).empty();
		$(".compare-product_name",selectorscompare.table).empty();
		$(".compare-product_image",selectorscompare.table).empty();
		$(".compare-product_variants",selectorscompare.table).empty();
		$(".compare-product_availability",selectorscompare.table).empty();
		$(".compare-product_price",selectorscompare.table).empty();
		$(".compare-product_atc",selectorscompare.table).empty();
		setupGridCompare(grid);
	}
	$(".compare-page .hide-button-compare").on( "click", function() {
		if($(".compare-page .content-compare").hasClass('active')){
			$(".compare-page .content-compare").removeClass('active');	
		}
	});
	$(".compare-page .show-compare").on( "click", function() {
		if(!$(".compare-page .content-compare").hasClass('active')){
			$(".compare-page .content-compare").addClass('active');	
		}
	});	
};
const initButtonsCompare = ($element) => {
	if($element){
		const parentElement = document.querySelector($element);
		let buttons = parentElement.querySelectorAll(selectorscompare.button) || [];
		if (buttons.length){
			setupButtonsCompare(buttons);
		}else return;
	}else{
		const buttons = document.querySelectorAll(selectorscompare.button) || [];
		if (buttons.length){
			setupButtonsCompare(buttons);
		}else return;	
	}
	const event = new CustomEvent('shopify-compare:init-buttons', {
		detail: { compare: getCompare() }
	});
	document.dispatchEvent(event);
	$(selectorscompare.button).each(function(event){
		if($(this).hasClass('active')){
			var $parent = $(this).closest('.button-compare');
			$parent.attr('data-title',window.strings.remove_compare);
		}else{
			var $parent = $(this).closest('.button-compare');
			$parent.attr('data-title',window.strings.compare);
		}
	});
};
const removeCompare = () => {
	const buttons = document.querySelectorAll(selectorscompare.remove) || [];
	if (buttons.length){
		removeButtonsCompare(buttons);
	}
	else return;
	const event = new CustomEvent('shopify-compare:init-buttons', {
		detail: { compare: getCompare() }
	});
	document.dispatchEvent(event);
};
const getCompare = () => {
	const compare = localStorage.getItem(LOCAL_STORAGE_COMPARE_KEY) || false;
	if (compare) return compare.split(LOCAL_STORAGE_DELIMITER_COMPARE);
	return [];
};
const setCompare = (array) => {
	const compare = array.join(LOCAL_STORAGE_DELIMITER_COMPARE);
	if (array.length) localStorage.setItem(LOCAL_STORAGE_COMPARE_KEY, compare);
		else localStorage.removeItem(LOCAL_STORAGE_COMPARE_KEY);
		const event = new CustomEvent('shopify-compare:updated', {
		detail: { compare: array }
	});
	document.dispatchEvent(event);
	return compare;
};
const updateCompare = (handle) => {
	const compare = getCompare();
	const indexInCompare = compare.indexOf(handle);
	const table = document.querySelector(selectorscompare.table);

	if (indexInCompare === -1) {
		compare.push(handle);
	}else{
		compare.splice(indexInCompare, 1);
	}

    if (compare.length === 0) {
		if($(".compare-page .content-compare").hasClass('active')){
			$(".compare-page .content-compare").removeClass('active');	
		}
    }
	if(compare.length === 0){
		table.classList.remove(GRID_LOADED_CLASS_COMPARE);
	}else{
		table.classList.add(GRID_LOADED_CLASS_COMPARE);
		$('.show-compare .count',selectorscompare.table).html(compare.length);
	}
	return setCompare(compare);
};
const compareContains = (handle) => {
	const compare = getCompare();
	return compare.includes(handle);
};
const resetCompare = () => {
	return setCompare([]);
};


